import React, { useEffect, useRef, useState } from "react";
import { API_ENDPOINT } from "../../../services/api/resources";
import { useSelector } from "react-redux/es/hooks/useSelector";
import axios from "axios";
import { masterDataRepository, rfqRepository, shouldMakeAPICall } from "../../../offline";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import classes from "./RFQTab.module.css";

import TextArea from "../../../components/common/TextArea/TextArea";
import DSelectInput from "../../../components/Dashboard/DashboardInputs/DSelectInput";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import Attachment from "../../../components/common/Attachment/Attachment";
import DFreeSoloInput from "../../../components/Dashboard/DashboardInputs/DFreeSoloInput";

import { Fade, Modal, Box, TextField, RadioGroup, FormControlLabel, Radio, IconButton } from "@mui/material";

import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import { AddCircleOutline, MoreHoriz, RemoveCircleOutline } from "@mui/icons-material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import DTextArea from "../../../components/Dashboard/DashboardInputs/DTextArea";
import { DatePicker, LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { emptyCheck, validateEmail } from "../../../utils/validations";
import vendorClasses from "../VendorsTab/VendorsTab.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import RFQSampleItemsFile from "../../../assets/files/RFQSampleItemsList.csv";
import QuickRFQShippingAddress from "./QuickRFQShippingAddress";

dayjs.extend(utc);

const QUICK_RFQ_UPLOAD_ACCEPT = ".csv,.xls,.xlsx";
const QUICK_RFQ_ALLOWED_EXTENSIONS = ["csv", "xls", "xlsx"];



const QuickRFQ = ({ closeQuickRFQ, onRfqCodeChange, mode = "quick" }) => {
    const isFreeRfq = mode === "free";

    const loginData = useSelector((state) => state.loginData.value);
    const mobileNumber = loginData?.user?.phone_number || "";



    const [buyer_token] = useState(loginData?.user?.token);
    const [auth_token] = useState(loginData?.auth_token);
    const [organization_token] = useState(loginData?.organization_token);
    const [user_token] = useState(loginData?.user?.token);
    const [org_name] = useState(loginData?.user?.company_name);


    const [getrfq, setRFQs] = useState([]);
    const [items, setItems] = useState([]);
    const [address, setAddress] = useState([]);


    const unitsOptions = [
        "Assemblies",
        "Dozen",
        "Each",
        "Feet",
        "Gallons",
        "Kilo",
        "Liters",
        "Metric Tons",
        "Meters",
        "Pieces",
        "Pounds",
        "Sets",
        "Tons",
        "Yards  ",
    ];


    // vendor list
    const [vendorsList, setVendorsList] = useState({
        values: {
            tokens: [],
            visibleOption: [],
        },
    });
    const [allVendorsList, setAllVendorsList] = useState({
        values: { tokens: [], visibleOption: [] },
        fullDetails: {},
    });
    const vendorFilterActiveRef = useRef(false);
    const [vendorId, setVendorID] = useState([]);
    const [vendor, setVendor] = useState({
        value: [],
        id: [],
        isValid: true,
    });

    const clearVendorSelection = () => {
        setVendorID([]);
        setVendor({ value: [], id: [], isValid: true });
    };

    const clearVendorsList = () => {
        setVendorsList({ values: { tokens: [], visibleOption: [] }, fullDetails: {} });
    };

    const clearVendorsForNoItem = () => {
        vendorFilterActiveRef.current = false;
        clearVendorsList();
        clearVendorSelection();
    };

    const [vendormessage, setVendorMessage] = useState({
        send_message: "",
    });
    const [selectedaddress, setSelectedAddress] = useState(null)


    const [getItemMaster, setItemMaster] = useState([])

    const [openvendormodal, setOpenModal] = useState(false)
    const [charsLeft, setCharsLeft] = useState(0);
    const [errorMessages, setErrorMessages] = useState(false);

    const [showmessagebtn, setMessageBtn] = useState(false)
    const [sendbtntext, setSendBtnText] = useState(false)

    const [successpopup, setSuccessPopUp] = useState(false);
    const [getuserpopupherotext, setUserPopupHeroText] = useState("");

    const [savedrfqtoken, setSavedRFQToken] = useState({})
    const [getvendorfileupload, setVendorFileUpload] = useState([]);
    const [freeRfqCode, setFreeRfqCode] = useState("");
    const [freeRfqCodeLoading, setFreeRfqCodeLoading] = useState(false);

    const [openaddvendor, setOpenAddVendor] = useState(false);
    const [CompanyName, setCompanyName] = useState({
        value: "",
        errorMsg: "",
        isValid: true,
    });
    const [companyList, setCompanyList] = useState([]);
    const [VendorRegisteredEmail, setVendorRegisteredEmail] = useState({
        value: "",
        errorMsg: "",
        isValid: true,
    });
    const [freeRfqRecipients, setFreeRfqRecipients] = useState([
        { mobile: "", email: "", mobileError: "", emailError: "", mobileValid: true, emailValid: true },
    ]);
    const [freeRfqValidationAttempted, setFreeRfqValidationAttempted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [primaryBtnError, setPrimaryBtnError] = useState({
        error: false,
        errorMsg: "",
    });
     const data = useSelector((state) => state.loginData.value);
    const [org_token, setOrgToken] = useState(data?.user?.token);
    const [prNumber, setPrNumber] = useState("");

    // const getFreeRfqOrganizationName = () =>
    //     String(
    //         loginData?.user?.company_name ||
    //             loginData?.organization_name ||
    //             loginData?.organizationName ||
    //             org_name ||
    //             "Organization"
    //     )
    //         .trim()
    //         .replace(/\s+/g, " ")
    //         .replace(/\//g, "-");

    // const getFreeRfqFinancialYear = (dateValue = dayjs()) => {
    //     const date = dayjs(dateValue);
    //     const year = date.year();
    //     const startYear = date.month() >= 3 ? year : year - 1;
    //     return `${startYear}-${startYear + 1}`;
    // };

    // const isValidMobileNumber = (value) => /^\d{10}$/.test(String(value || "").trim());
    // const isValidFreeRfqEmail = (value) => validateEmail(String(value || "").trim());

    // const freeRfqRecipientError =
    //     (!String(freeRfqMobileNumber?.value || "").trim() &&
    //         !String(freeRfqEmail?.value || "").trim())
    //         ? "Enter mobile number or email"
    //         : String(freeRfqMobileNumber?.value || "").trim() &&
    //           !isValidMobileNumber(freeRfqMobileNumber?.value)
    //         ? "Enter a valid 10 digit mobile number"
    //         : String(freeRfqEmail?.value || "").trim() && !isValidFreeRfqEmail(freeRfqEmail?.value)
    //         ? "Enter a valid email address"
    //         : "";

    // const isFreeRfqReadyToSend = React.useMemo(() => {
    //     if (!isFreeRfq) return false;
    //     const hasRecipient =
    //         String(freeRfqMobileNumber?.value || "").trim() ||
    //         String(freeRfqEmail?.value || "").trim();

    //     const mobileOk =
    //         !String(freeRfqMobileNumber?.value || "").trim() ||
    //         isValidMobileNumber(freeRfqMobileNumber?.value);
    //     const emailOk =
    //         !String(freeRfqEmail?.value || "").trim() ||
    //         isValidFreeRfqEmail(freeRfqEmail?.value);

    //     const hasAddress = Boolean(selectedaddress);
    //     const hasDates = Boolean(bidstartdate && bidenddate && bidendtime);
    //     const hasItems = Array.isArray(items) && items.length > 0;
    //     const itemsValid =
    //         hasItems &&
    //         items.every((item) =>
    //             Boolean(
    //                 String(item?.itemName || "").trim() &&
    //                     String(item?.itemCode || "").trim() &&
    //                     String(item?.unit || "").trim() &&
    //                     String(item?.quantity || "").trim() &&
    //                     String(item?.description || "").trim(),
    //             ),
    //         );

    //     return Boolean(
    //         hasRecipient &&
    //             mobileOk &&
    //             emailOk &&
    //             hasAddress &&
    //             hasDates &&
    //             itemsValid,
    //     );
    // }, [bidenddate, bidendtime, bidstartdate, freeRfqEmail?.value, freeRfqMobileNumber?.value, isFreeRfq, items, selectedaddress]);


    const [openAddAddressModal, setOpenAddAddressModal] = useState(false);




    const [bidstartdate, setBidStartDate] = useState(dayjs());
    const [bidenddate, setBidEndDate] = useState(dayjs().add(1, "day"));
    // const [bidendtime, setBitEndTime] = useState(dayjs());
    // const [bidendtime, setBitEndTime] = useState(dayjs().add(1, "day").endOf("day").utc().hour(23).minute(59).second(0).millisecond(0));
    const [bidendtime, setBitEndTime] = useState(
        dayjs().utc().hour(11).minute(59).second(0).millisecond(0)
    );

    const [fileUpload, setFileUpload] = useState(null);
    const [inputMethod, setInputMethod] = useState("xls");
    const [bidType, setBidType] = useState("0");
    const [proposalDoc, setProposalDoc] = useState("");
    const [quickRfqSubmitError, setQuickRfqSubmitError] = useState({
        field: "",
        message: "",
    });

    const xlsUploadRef = useRef(null);
    const manualItemsRef = useRef(null);
    const xlsFileInputRef = useRef(null);
    const prNumberRef = useRef(null);
    const prNumberInputRef = useRef(null);

    const [dragging, setDragging] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const getFreeRfqOrganizationName = () =>
        String(
            loginData?.user?.company_name ||
                loginData?.organization_name ||
                loginData?.organizationName ||
                org_name ||
                "Organization"
        )
            .trim()
            .replace(/\s+/g, " ")
            .replace(/\//g, "-");

    const getFreeRfqFinancialYear = (dateValue = dayjs()) => {
        const date = dayjs(dateValue);
        const year = date.year();
        const startYear = date.month() >= 3 ? year : year - 1;
        return `${startYear}-${startYear + 1}`;
    };

    const isValidMobileNumber = (value) => /^\d{10}$/.test(String(value || "").trim());
    const isValidFreeRfqEmail = (value) => validateEmail(String(value || "").trim());

    const updateFreeRfqRecipient = (index, field, value) => {
        const normalizedValue = field === "mobile"
            ? String(value || "").replace(/\D/g, "").slice(0, 10)
            : String(value || "");

        setPrimaryBtnError({ error: false, errorMsg: "" });
        setFreeRfqValidationAttempted(false);
        setFreeRfqRecipients((prev) =>
            prev.map((row, rowIndex) =>
                rowIndex === index
                    ? {
                          ...row,
                          [field]: normalizedValue,
                          ...(field === "mobile"
                              ? { mobileError: "", mobileValid: true }
                              : {}),
                          ...(field === "email"
                              ? { emailError: "", emailValid: true }
                              : {}),
                      }
                    : row,
            ),
        );
    };

    const addFreeRfqRecipientRow = () => {
        setFreeRfqRecipients((prev) => [
            ...prev,
            {
                mobile: "",
                email: "",
                mobileError: "",
                emailError: "",
                mobileValid: true,
                emailValid: true,
            },
        ]);
    };

    const removeFreeRfqRecipientRow = (index) => {
        setFreeRfqRecipients((prev) => {
            const next = prev.filter((_, rowIndex) => rowIndex !== index);
            return next.length
                ? next
                : [
                      {
                          mobile: "",
                          email: "",
                          mobileError: "",
                          emailError: "",
                          mobileValid: true,
                          emailValid: true,
                      },
                  ];
        });
    };

    const validateFreeRfqRecipients = (rows = []) => {
        const nextRows = rows.map((row) => {
            const mobile = String(row?.mobile || "").trim();
            const email = String(row?.email || "").trim();
            const hasAny = Boolean(mobile || email);
            const mobileValid = !mobile || isValidMobileNumber(mobile);
            const emailValid = !email || isValidFreeRfqEmail(email);

            return {
                ...row,
                mobileValid: hasAny ? mobileValid : false,
                emailValid: hasAny ? emailValid : false,
                mobileError: !hasAny
                    ? "Enter mobile number or email"
                    : mobile && !mobileValid
                    ? "Enter a valid 10 digit mobile number"
                    : "",
                emailError: !hasAny
                    ? "Enter mobile number or email"
                    : email && !emailValid
                    ? "Enter a valid email address"
                    : "",
            };
        });

        const hasAnyRecipient = nextRows.some((row) => String(row.mobile || "").trim() || String(row.email || "").trim());
        const hasValidRecipient = nextRows.some((row) => {
            const mobile = String(row.mobile || "").trim();
            const email = String(row.email || "").trim();
            return (
                (mobile ? isValidMobileNumber(mobile) : true) &&
                (email ? isValidFreeRfqEmail(email) : true) &&
                Boolean(mobile || email)
            );
        });

        return {
            rows: nextRows,
            canSend: hasAnyRecipient && hasValidRecipient,
            error: hasAnyRecipient && hasValidRecipient
                ? ""
                : "Enter at least one valid mobile number or email address.",
        };
    };

    const freeRfqRecipientValidation = React.useMemo(
        () => validateFreeRfqRecipients(freeRfqRecipients),
        [freeRfqRecipients],
    );

    const freeRfqRecipientError =
        freeRfqValidationAttempted ? freeRfqRecipientValidation.error : "";

    const isFreeRfqReadyToSend = React.useMemo(() => {
        if (!isFreeRfq) return false;

        const hasAddress = Boolean(selectedaddress);
        const hasDates = Boolean(bidstartdate && bidenddate && bidendtime);
        const hasManualItems = Array.isArray(items) && items.length > 0;
        const manualItemsValid =
            hasManualItems &&
            items.every((item) =>
                Boolean(
                    String(item?.itemName || "").trim() &&
                        String(item?.itemCode || "").trim() &&
                        String(item?.unit || "").trim() &&
                        String(item?.quantity || "").trim() &&
                        String(item?.description || "").trim(),
                ),
            );
        const hasUploadedFile = Boolean(fileUpload);
        const hasValidItemSource = inputMethod === "xls" ? hasUploadedFile : manualItemsValid;

        return Boolean(
            freeRfqRecipientValidation.canSend &&
                hasAddress &&
                hasDates &&
                hasValidItemSource,
        );
    }, [bidenddate, bidendtime, bidstartdate, fileUpload, freeRfqRecipientValidation.canSend, inputMethod, isFreeRfq, items, selectedaddress]);

    const handleFreeRfqSendInvite = async () => {
        setFreeRfqValidationAttempted(true);
        setPrimaryBtnError({ error: false, errorMsg: "" });

        const validation = validateFreeRfqRecipients(freeRfqRecipients);
        setFreeRfqRecipients(validation.rows);

        if (!validation.canSend) return;

        const hasUploadedFile = inputMethod === "xls" && Boolean(fileUpload);
        const hasManualItems = Array.isArray(items) && items.length > 0;

        if (!selectedaddress || (!hasUploadedFile && !hasManualItems)) {
            setPrimaryBtnError({
                error: true,
                errorMsg: "Please complete the easyRFQ details before sending the invite.",
            });
            return;
        }

        const incompleteItem =
            inputMethod === "manual"
                ? items.find((item) =>
                      !String(item?.itemName || "").trim() ||
                      !String(item?.itemCode || "").trim() ||
                      !String(item?.unit || "").trim() ||
                      !String(item?.quantity || "").trim() ||
                      !String(item?.description || "").trim()
                  )
                : null;

        if (inputMethod === "manual" && incompleteItem) {
            setPrimaryBtnError({
                error: true,
                errorMsg: "Please fill all item details before sending the invite.",
            });
            return;
        }

        const emails = validation.rows
            .map((row) => String(row.email || "").trim())
            .filter(Boolean);

        if (isFreeRfq && !String(freeRfqCode || "").trim()) {
            setPrimaryBtnError({
                error: true,
                errorMsg: "easyRFQ ID is still loading. Please try again in a moment.",
            });
            return;
        }

        setLoading(true);
        try {
            const payload = {
                user_token: loginData?.user?.token || user_token,
                "RFQ Code": isFreeRfq
                    ? freeRfqCode
                    : `Q-RFQ_${nextRFQNumber}/${getFreeRfqOrganizationName()}/${getFreeRfqFinancialYear()}/${dayjs().format("MMM").toUpperCase()}/${prNumber}`,
                "Bid Type": "1",
                "Proposal Document": "No",
                shipping_address1: selectedaddress?.shipping_address1 || "",
                shipping_address2: selectedaddress?.shipping_address2 || "",
                city: selectedaddress?.city || "",
                state: selectedaddress?.state || "",
                country: selectedaddress?.country || "",
                pincode: selectedaddress?.pincode || "",
                mobile_number: mobileNumber || "",
                purchase_request_number: prNumber || "PR-FREE-001",
                expense_type: items?.[0]?.expenseType || items?.[0]?.expense_type || "IT",
                bid_from_date: dayjs(bidstartdate).format("YYYY-MM-DD"),
                bid_to_date: dayjs(bidenddate).format("YYYY-MM-DD"),
                bid_time: dayjs(bidendtime).format("HH:mm"),
                vendorInfo: [
                    ...validation.rows.map((row) => ({
                        email: String(row.email || "").trim(),
                        mobile_number:
                            String(row.mobile || "").trim(),
                    })),
                ],
                email: emails.join(","),
                items: items.map((item) => ({
                    itemName: item?.itemName || item?.item_name || "",
                    itemCode: item?.itemCode || item?.item_code || "",
                    itemToken: item?.itemToken || item?.item_token || "",
                    category: item?.category || "",
                    hsnCode: item?.hsnCode || item?.hsn_code || "",
                    unspscCode: item?.unspscCode || item?.unspsc_code || "",
                    subCategory: item?.subCategory || item?.sub_category || "",
                    itemType: item?.itemType || item?.item_type || "",
                    quantity: Number(item?.quantity || 0),
                    unit: item?.unit || "",
                    description: item?.description || "",
                    expense_type: item?.expenseType || item?.expense_type || "",
                    brand: item?.brand || "",
                    partNumber: item?.partNumber || item?.part_number || "",
                    specifications: item?.specifications || "",
                    aliases: item?.aliases || "",
                    GST_list: item?.gstList || item?.GST_list || [],
                    unitPrice: Number(item?.unitPrice || item?.unit_price || 0),
                    totalPrice: Number(item?.totalPrice || item?.total_price || 0),
                    item_name: item?.itemName || item?.item_name || "",
                    item_code: item?.itemCode || item?.item_code || "",
                    item_token: item?.itemToken || item?.item_token || "",
                    hsn_code: item?.hsnCode || item?.hsn_code || "",
                    unspsc_code: item?.unspscCode || item?.unspsc_code || "",
                    sub_category: item?.subCategory || item?.sub_category || "",
                    item_type: item?.itemType || item?.item_type || "",
                    part_number: item?.partNumber || item?.part_number || "",
                    gst_list: item?.gstList || item?.GST_list || [],
                    unit_price: Number(item?.unitPrice || item?.unit_price || 0),
                    total_price: Number(item?.totalPrice || item?.total_price || 0),
                })),
            };

            let requestBody = payload;
            if (hasUploadedFile) {
                requestBody = new FormData();
                Object.entries(payload).forEach(([key, value]) => {
                    requestBody.append(
                        key,
                        typeof value === "object" ? JSON.stringify(value) : value,
                    );
                });
                requestBody.append("document", fileUpload);
            }

            const response = await axios.post(API_ENDPOINT.free_rfq, requestBody, {
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            });

            setFreeRfqValidationAttempted(false);
            setSuccessPopUp(true);
            setUserPopupHeroText(
                response?.data?.message ||
                    response?.data?.msg ||
                    "easyRFQ invite sent successfully."
            );
        } catch (error) {
            console.error("Error sending easyRFQ invite:", error);
            const errorData = error?.response?.data;
            const errorMessage =
                errorData?.response ||
                errorData?.message ||
                errorData?.msg ||
                "Unable to send easyRFQ invite.";
            const missingFields = Array.isArray(errorData?.missing_fields)
                ? errorData.missing_fields.join(", ")
                : "";
            setPrimaryBtnError({
                error: true,
                errorMsg: missingFields
                    ? `${errorMessage} Missing fields: ${missingFields}.`
                    : errorMessage,
            });
        } finally {
            setLoading(false);
        }
    };

    const normalizeLooseCell = (value) =>
        String(value ?? "")
            .replace(/\s+/g, " ")
            .trim();

    const extractItemTokensFromQuickRFQUploadFile = async (file) => {
        try {
            if (!file) return [];

            const ext = String(file?.name || "")
                .split(".")
                .pop()
                ?.toLowerCase();

            let workbook = null;

            if (ext === "csv") {
                const csvText =
                    typeof file.text === "function"
                        ? await file.text()
                        : await new Promise((resolve, reject) => {
                              const reader = new FileReader();
                              reader.onload = () => resolve(reader.result);
                              reader.onerror = () => reject(reader.error || new Error("Failed to read file"));
                              reader.readAsText(file);
                          });
                workbook = XLSX.read(csvText, { type: "string" });
            } else {
                const buffer =
                    typeof file.arrayBuffer === "function"
                        ? await file.arrayBuffer()
                        : await new Promise((resolve, reject) => {
                              const reader = new FileReader();
                              reader.onload = () => resolve(reader.result);
                              reader.onerror = () => reject(reader.error || new Error("Failed to read file"));
                              reader.readAsArrayBuffer(file);
                          });
                workbook = XLSX.read(buffer, { type: "array" });
            }

            const sheetName = workbook?.SheetNames?.[0];
            if (!sheetName) return [];
            const sheet = workbook.Sheets[sheetName];
            const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            const itemCodes = (rows || [])
                .map((r) =>
                    normalizeLooseCell(
                        r?.item_code ?? r?.itemCode ?? r?.["Item Code"] ?? r?.["ITEM CODE"],
                    ),
                )
                .filter(Boolean);

            const itemNames = (rows || [])
                .map((r) =>
                    normalizeLooseCell(
                        r?.item_name ?? r?.itemName ?? r?.["Item Name"] ?? r?.["ITEM NAME"],
                    ),
                )
                .filter(Boolean);

            let masterList = Array.isArray(getItemMaster) ? getItemMaster : [];
            if (masterList.length === 0) {
                const cachedItems = await masterDataRepository.getItemsFromCache();
                if (Array.isArray(cachedItems) && cachedItems.length > 0) {
                    masterList = cachedItems;
                }
            }

            if (!Array.isArray(masterList) || masterList.length === 0) return [];

            const codeToToken = new Map();
            const nameToToken = new Map();

            masterList.forEach((it) => {
                const token = String(it?.token || it?.item_token || "").trim();
                if (!token) return;
                const codeKey = normalizeLooseCell(it?.item_code).toLowerCase();
                const nameKey = normalizeLooseCell(it?.item_name).toLowerCase();
                if (codeKey) codeToToken.set(codeKey, token);
                if (nameKey) nameToToken.set(nameKey, token);
            });

            const resolved = [];
            itemCodes.forEach((c) => {
                const token = codeToToken.get(String(c).toLowerCase());
                if (token) resolved.push(token);
            });
            itemNames.forEach((n) => {
                const token = nameToToken.get(String(n).toLowerCase());
                if (token) resolved.push(token);
            });

            return [...new Set(resolved.map((t) => String(t).trim()).filter(Boolean))];
        } catch (e) {
            console.warn("Failed to parse Quick RFQ file for vendor filtering:", e);
            return [];
        }
    };

    const applyVendorFilterFromUploadedFile = async (file) => {
        if (inputMethod !== "xls") return;

        if (!file) {
            clearVendorsForNoItem();
            return;
        }

        const itemTokens = await extractItemTokensFromQuickRFQUploadFile(file);
        if (itemTokens.length > 0) {
            void getVendorsByCategory(itemTokens);
        } else {
            clearVendorsForNoItem();
        }
    };

   



    // useEffect(() => {
    //     const today = new Date();
    //     const tomorrow = new Date();
    //     tomorrow.setDate(today.getDate() + 1);

    //     const formatDate = (date) => date.toISOString().split("T")[0];
    //     const defaultTime = "12:00:00.000Z";
    //     const nowtime = new Date().getTime()

    //     setBidStartDate(formatDate(today) + "T" + defaultTime);
    //     setBidEndDate(formatDate(tomorrow) + "T" + defaultTime);
    // }, []);

    useEffect(() => {
        setBidStartDate(dayjs());
        setBidEndDate(dayjs().add(1, "day"));
        setBitEndTime(dayjs().add(1, "day").endOf("day"));
    }, []);



    const get_rfqs = async () => {
        try {
            const rfqListEndpoint = isFreeRfq
                ? API_ENDPOINT.get_free_rfq_list
                : API_ENDPOINT.get_all_buyer_RFQ;
            const payload = isFreeRfq
                ? {
                    user_token: buyer_token,
                    page: 1,
                    page_size: 20,
                }
                : {
                    page: 1,
                    org_token: buyer_token,
                };

            const response = await axios({
                url: `${rfqListEndpoint}`,
                method: "POST",
                data: payload,
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            });

            const rfqRows = Array.isArray(response?.data?.results)
                ? response.data.results
                : Array.isArray(response?.data)
                    ? response.data
                    : [];
            setRFQs(rfqRows);
        } catch (error) {
            console.error("Error fetching RFQs:", error);
            setRFQs([]);
        }
    };

    const get_all_vendors = async () => {
        // Try cache first
        const cachedVendors = await masterDataRepository.getVendorsFromCache();
        if (cachedVendors && cachedVendors.length > 0) {
            const nextAll = {
                values: {
                    tokens: cachedVendors.map((vendor) => vendor.token),
                    visibleOption: cachedVendors.map((vendor) => `${vendor.company_name} (${vendor.company_official_email})`),
                },
                fullDetails: cachedVendors.reduce((acc, vendor) => {
                    acc[vendor.token] = {
                        token: vendor.token,
                        companyName: vendor.company_name,
                        email: vendor.company_official_email,
                        role: vendor.role,
                    };
                    return acc;
                }, {}),
            };
            setAllVendorsList(nextAll);
            // Don't show all vendors by default; vendor options are shown only after item selection.
        }

        // Sync from API if online
        if (shouldMakeAPICall(auth_token, buyer_token)) {
            await axios({
                method: "POST",
                url: `${API_ENDPOINT.get_all_vendor}`,
                data: {
                    org_token: buyer_token,
                },
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            })
                .then(async (res) => {
                    const vendors = res?.data?.users || [];
                    // Save to cache
                    await masterDataRepository.saveVendorsToCache(vendors);
                    
                    const nextAll = {
                        values: {
                            tokens: vendors.map((vendor) => vendor.token),
                            visibleOption: vendors.map((vendor) => `${vendor.company_name} (${vendor.company_official_email})`),
                        },
                        fullDetails: vendors.reduce((acc, vendor) => {
                            acc[vendor.token] = {
                                token: vendor.token,
                                companyName: vendor.company_name,
                                email: vendor.company_official_email,
                                role: vendor.role,
                            };
                            return acc;
                        }, {}),
                    };
                    setAllVendorsList(nextAll);
                    // Don't show all vendors by default; vendor options are shown only after item selection.
                })
                .catch((err) => {
                    // Network errors are expected when offline - silently use cache
                    if (err.code === 'ERR_NETWORK' || err.code === 'ERR_CONNECTION_REFUSED') {
                        console.log('📴 Network error - using cached vendors');
                    } else {
                        console.log('Error loading vendors, using cache:', err);
                    }
                    // Use cached data if API fails
                    if (cachedVendors && cachedVendors.length > 0) {
                        const nextAll = {
                            values: {
                                tokens: cachedVendors.map((vendor) => vendor.token),
                                visibleOption: cachedVendors.map((vendor) => `${vendor.company_name} (${vendor.company_official_email})`),
                            },
                            fullDetails: cachedVendors.reduce((acc, vendor) => {
                                acc[vendor.token] = {
                                    token: vendor.token,
                                    companyName: vendor.company_name,
                                    email: vendor.company_official_email,
                                    role: vendor.role,
                                };
                                return acc;
                            }, {}),
                        };
                        setAllVendorsList(nextAll);
                        // Don't show all vendors by default; vendor options are shown only after item selection.
                    }
                });
        }
    }

    const getAllItems = async () => {
        // Try cache first
        const cachedItems = await masterDataRepository.getItemsFromCache();
        if (cachedItems && cachedItems.length > 0) {
            setItemMaster(cachedItems);
        }

        // Sync from API if online
        if (shouldMakeAPICall(auth_token, buyer_token)) {
            try {
                const response = await axios.post(
                    `${API_ENDPOINT.view_all_item}`,
                    { org_token: user_token },
                    { headers: { Authorization: `Bearer ${auth_token}` } }
                );

                if (response.data?.response) {
                    const items = response?.data?.response;
                    // Save to cache
                    await masterDataRepository.saveItemsToCache(items);
                    setItemMaster(items);
                } else {
                    console.error("API response is not an array:", response.data);
                    // Use cached data if available
                    if (cachedItems && cachedItems.length > 0) {
                        setItemMaster(cachedItems);
                    } else {
                        setItemMaster([]);
                    }
                }
            } catch (error) {
                // Network errors are expected when offline - silently use cache
                if (error.code === 'ERR_NETWORK' || error.code === 'ERR_CONNECTION_REFUSED') {
                    console.log('📴 Network error - using cached items');
                } else {
                    console.error("Error fetching items:", error);
                }
                // Use cached data if available
                if (cachedItems && cachedItems.length > 0) {
                    setItemMaster(cachedItems);
                } else {
                    setItemMaster([]);
                }
            }
        }
    };

    const get_rfq_address = async () => {
        // Try RFQ addresses from buyer_rfq_full_view API response first
        const rfqAddresses = await rfqRepository.getRFQAddressesFromCache(buyer_token);
        if (rfqAddresses && rfqAddresses.length > 0) {
            console.log(`📦 Using ${rfqAddresses.length} RFQ addresses from cache`);
            setAddress(rfqAddresses);
        }
        
        // Try regular shipping addresses cache
        const cachedAddresses = await masterDataRepository.getShippingAddressesFromCache(user_token);
        if (cachedAddresses && cachedAddresses.length > 0 && (!rfqAddresses || rfqAddresses.length === 0)) {
            setAddress(cachedAddresses);
        }

        // Sync from API if online
        if (shouldMakeAPICall(auth_token, buyer_token)) {
            try {
                const response = await axios({
                    url: `${API_ENDPOINT.rfq_address}`,
                    method: "POST",
                    data: {
                        "buyer_token": buyer_token
                    },
                    headers: {
                        Authorization: `Bearer ${auth_token}`,
                    },
                });

                const addresses = response.data || [];
                // Save to cache (as shipping addresses)
                await masterDataRepository.saveShippingAddressesToCache(addresses, user_token);
                setAddress(addresses);
            } catch (error) {
                // Network errors are expected when offline - silently use cache
                if (error.code === 'ERR_NETWORK' || error.code === 'ERR_CONNECTION_REFUSED') {
                    console.log('📴 Network error - using cached addresses');
                } else {
                    console.error("Error fetching addresses:", error);
                }
                // Use cached data if available
                if (rfqAddresses && rfqAddresses.length > 0) {
                    setAddress(rfqAddresses);
                } else if (cachedAddresses && cachedAddresses.length > 0) {
                    setAddress(cachedAddresses);
                } else {
                    setAddress([]);
                }
            }
        }
    };
    

    useEffect(() => {
        get_rfqs();
        get_all_vendors()
        getAllItems()
        get_rfq_address()
    }, []);

    useEffect(() => {
        if (!isFreeRfq) return;

        const createFreeRfqId = async () => {
            if (!shouldMakeAPICall(auth_token, buyer_token)) {
                return;
            }

            setFreeRfqCodeLoading(true);
            try {
                const response = await axios.post(
                    API_ENDPOINT.create_easy_rfq_id,
                    {
                        user_token: buyer_token,
                        buyer_name:
                            loginData?.user?.name ||
                            loginData?.user?.full_name ||
                            loginData?.user?.first_name ||
                            loginData?.user?.company_name ||
                            org_name ||
                            "",
                        buyer_email: loginData?.user?.email || loginData?.user?.official_email || "",
                        buyer_company_name:
                            loginData?.user?.company_name ||
                            loginData?.organization_name ||
                            loginData?.organizationName ||
                            org_name ||
                            "",
                        created_at: dayjs().format("YYYY-MM-DD"),
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${auth_token}`,
                        },
                    },
                );

                const nextCode = String(response?.data?.rfq_code || "").trim();
                if (nextCode) {
                    setFreeRfqCode(nextCode);
                }
            } catch (error) {
                console.error("Error creating easy RFQ id:", error);
                setFreeRfqCode("");
            } finally {
                setFreeRfqCodeLoading(false);
            }
        };

        void createFreeRfqId();
    }, [auth_token, buyer_token, isFreeRfq, loginData, org_name]);

    useEffect(() => {
        if (inputMethod === "xls") {
            void applyVendorFilterFromUploadedFile(fileUpload);
            return;
        }

        // manual mode: filter based on selected item(s); show nothing until item(s) selected
        const tokens = (items || []).map((it) => it?.itemToken).filter(Boolean);
        if (tokens.length > 0) {
            vendorFilterActiveRef.current = true;
            void getVendorsByCategory(tokens);
        } else {
            clearVendorsForNoItem();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputMethod]);


    const org_details = [
        {
            label: "RFQ ID",
            size: "30rem",
        },
        // {
        //     label: "Bid Type",
        //     value: "Closed",
        //     size: "10rem",
        // },
        // {
        //     label: "Proposal Document",
        //     value: "No",
        //     size: "14rem",
        // }
    ];

    const extractRfqCodeText = (rfq = {}) => {
        const candidateValues = [
            rfq?.rfq_code,
            rfq?.rfqCode,
            rfq?.RFQ_Code,
            rfq?.RFQCode,
            rfq?.code,
            rfq?.value,
            rfq?.name,
        ]
            .flatMap((value) =>
                typeof value === "string"
                    ? [value]
                    : value && typeof value === "object"
                        ? Object.values(value).filter((entry) => typeof entry === "string")
                        : [],
            )
            .map((value) => String(value || "").trim())
            .filter(Boolean);

        return candidateValues.find((value) => /[EQ]-RFQ[_-]\d+/i.test(value)) || "";
    };

    const rfqData =
        getrfq
            ?.map((rfq) => {
                const code = extractRfqCodeText(rfq);
                const freeMatch =
                    code.match(/^E[-_]RFQ[_-](\d+)(?:\/([^\/]+)\/([\d-]+)\/([A-Z]+)\/?.*)?$/i) ||
                    code.match(/^e[-_]rfq[_-](\d+)(?:\/([^\/]+)\/([\d-]+)\/([A-Z]+)\/?.*)?$/i);
                const quickMatch =
                    code.match(/^Q[-_]RFQ[_-](\d+)(?:\/([^\/]+)\/([\d-]+)\/([A-Z]+)\/(.+))?$/i) ||
                    code.match(/^q[-_]rfq[_-](\d+)(?:\/([^\/]+)\/([\d-]+)\/([A-Z]+)\/(.+))?$/i);
                const match = freeMatch || quickMatch;

                if (!match) return null;

                return {
                    number: parseInt(match[1], 10),
                    organization: match[2] || "",
                    type: freeMatch ? "free" : "quick",
                };
            })
            .filter((item) => item !== null) || [];

    const nextRFQNumber = rfqData.length > 0 ? Math.max(...rfqData.map(item => item.number)) + 1 : 1000;
    const loginOrganizationName =
        String(
            loginData?.user?.company_name ||
                loginData?.organization_name ||
                loginData?.organizationName ||
                "Organization",
        ).trim() || "Organization";
    const organizationName = isFreeRfq
        ? loginOrganizationName
        : rfqData.length > 0
            ? rfqData[rfqData.length - 1].organization
            : "Default Org";

    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;
    const financialYear = `${currentYear}-${nextYear}`;
    const currentMonth = new Date().toLocaleString('en-US', { month: 'short' }).toUpperCase();

    const newRfqCode = isFreeRfq
        ? freeRfqCode || ""
        : `Q-RFQ_${nextRFQNumber}/${organizationName}/${financialYear}/${currentMonth}/${prNumber}`;
    org_details[0].value = newRfqCode;

    useEffect(() => {
        if (typeof onRfqCodeChange === "function") {
            onRfqCodeChange(newRfqCode);
        }
    }, [newRfqCode, onRfqCodeChange]);

    const getQuickRfqItemKey = (item = {}) =>
        String(item?.itemCode || "").trim().toLowerCase();

    const hasQuickItemKeyConflict = (list = [], index) => {
        const current = list?.[index];
        if (!current) return false;
        const key = getQuickRfqItemKey(current);
        if (!key) return false;
        return (list || []).some((other, idx) => {
            if (idx === index) return false;
            return getQuickRfqItemKey(other) === key;
        });
    };

    const clearResolvedQuickDuplicateFlags = (list = []) => {
        const next = (list || []).map((item) => ({ ...item }));
        next.forEach((item, idx) => {
            if (!item.itemDuplicate) return;
            const stillConflicts = hasQuickItemKeyConflict(next, idx);
            if (!stillConflicts) item.itemDuplicate = false;
        });
        return next;
    };

    const markQuickDuplicateForIndexOnly = (list = [], index) => {
        const next = clearResolvedQuickDuplicateFlags(list);
        if (!next[index]) return next;
        const key = getQuickRfqItemKey(next[index]);
        const isDup = hasQuickItemKeyConflict(next, index);
        if (isDup && key) {
            next.forEach((item, idx) => {
                if (idx === index) return;
                if (item.itemDuplicate && getQuickRfqItemKey(item) === key) {
                    item.itemDuplicate = false;
                }
            });
        }
        next[index].itemDuplicate = isDup;
        return next;
    };

    const markLatestQuickDuplicatesForSubmit = (list = []) => {
        const next = clearResolvedQuickDuplicateFlags(list);
        const indicesByKey = new Map();
        next.forEach((item, idx) => {
            const key = getQuickRfqItemKey(item);
            if (!key) return;
            const existing = indicesByKey.get(key);
            if (existing) existing.push(idx);
            else indicesByKey.set(key, [idx]);
        });
        indicesByKey.forEach((indices) => {
            if (indices.length <= 1) return;
            const latestIdx = Math.max(...indices);
            indices.forEach((i) => {
                if (next[i]) next[i].itemDuplicate = false;
            });
            if (next[latestIdx]) next[latestIdx].itemDuplicate = true;
        });
        return next;
    };

    const hasAnyQuickDuplicates = (list = []) => {
        const seen = new Set();
        for (const item of list || []) {
            const key = getQuickRfqItemKey(item);
            if (!key) continue;
            if (seen.has(key)) return true;
            seen.add(key);
        }
        return false;
    };

    const addNewItem = () => {
        if (quickRfqSubmitError.field === "manual") {
            setQuickRfqSubmitError({ field: "", message: "" });
        }
        setItems((prev) => [
            ...(prev || []),
            {
                itemName: "",
                expenseType: "",
                itemCode: "",
                itemToken: "",
                hsnCode: "",
                unspscCode: "",
                category: "",
                subCategory: "",
                itemType: "",
                brand: "",
                partNumber: "",
                specifications: "",
                aliases: "",
                tax: "",
                gstList: [],
                unit: "",
                quantity: "",
                description: "",
                itemDuplicate: false,
            },
        ]);
    };

    useEffect(() => {
        if (inputMethod !== "manual") return;
        if (Array.isArray(items) && items.length > 0) return;

        setItems([
            {
                itemName: "",
                expenseType: "",
                itemCode: "",
                itemToken: "",
                hsnCode: "",
                unspscCode: "",
                category: "",
                subCategory: "",
                itemType: "",
                brand: "",
                partNumber: "",
                specifications: "",
                aliases: "",
                tax: "",
                gstList: [],
                unit: "",
                quantity: "",
                description: "",
                itemDuplicate: false,
            },
        ]);
    }, [inputMethod, items]);

    const handleInputChange = (index, field, value) => {
        if (quickRfqSubmitError.field === "manual") {
            setQuickRfqSubmitError({ field: "", message: "" });
        }
        if (field === "quantity") {
            const raw = String(value ?? "");
            const sanitized = raw.replace(/\D/g, "").slice(0, 10);

            const updatedItems = [...items];
            updatedItems[index][field] = sanitized;
            setItems(updatedItems);
            return;
        }

        const updatedItems = [...items];
        updatedItems[index][field] = value;
        setItems(updatedItems);
    };

    const removeItem = (index) => {
        const updatedItems = clearResolvedQuickDuplicateFlags(
            (items || []).filter((_, i) => i !== index),
        );
        setItems(updatedItems);

        const tokens = (updatedItems || []).map((it) => it?.itemToken).filter(Boolean);
        if (tokens.length > 0) {
            vendorFilterActiveRef.current = true;
            void getVendorsByCategory(tokens);
        } else {
            clearVendorsForNoItem();
        }

        const hasDup = updatedItems.some((i) => i.itemDuplicate);
        if (!hasDup && primaryBtnError?.errorMsg?.includes("Item already added")) {
            setPrimaryBtnError({ error: false, errorMsg: "" });
        }
    };


    const handleVendorSelection = (value) => {
        setVendor({
            value: value,
            isValid: value?.length !== 0,
        });
    };

    const handleWordCount = (event) => {
        const inputValue = event.target.value;
        const charCount = inputValue.length;
        const maxChar = 2000;
        const truncatedValue = inputValue.slice(0, maxChar);
        setVendorMessage({ ...vendormessage, send_message: truncatedValue });
        const charLength = Math.min(maxChar, charCount); // Ensures the count doesn't exceed 200
        setCharsLeft(charLength);
    };


    const handleVendorMessagePopup = () => {
        setOpenModal(true)
    }

    const handleVendorMessageClosePopup = () => {
        setVendorMessage({ ...vendormessage, send_message: "" });
        setOpenModal(false)
    }


    const handleuserFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setVendorFileUpload((prefiles) => [...prefiles, file]);
        }
    };

    const handleUserRemoveFile = (index) => {
        setVendorFileUpload((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };



    const handleSendVendorMessage = async () => {

        // let requestData = {
        //     sender_token: user_token,
        //     sender_role: loginData?.user?.role,
        //     receiver_token: vendor?.fullDetails.map(item => item.token).join(","),
        //     receiver_role: vendor?.fullDetails.map(item => item.role).join(","),
        //     rfq_token: savedrfqtoken.rfq_token,
        //     message: vendormessage.send_message,
        //     rfqcon_files:
        // }

        // // rfqcon_files:getvendorfileupload,
        // if (getvendorfileupload && getvendorfileupload.length > 0) {
        //     requestData.rfqcon_files = getvendorfileupload;
        // }

        let formData = new FormData();

        // Append text fields
        formData.append("sender_token", user_token);
        formData.append("sender_role", loginData?.user?.role);
        formData.append("receiver_token", vendor?.fullDetails.map(item => item.token).join(",")); // Comma-separated tokens
        formData.append("receiver_role", vendor?.fullDetails.map(item => item.role).join(",")); // Comma-separated roles
        formData.append("rfq_token", savedrfqtoken.rfq_token);
        formData.append("message", vendormessage.send_message);

        if (getvendorfileupload) {
            getvendorfileupload.forEach(file => {
                formData.append('rfqcon_files', file)

            })
        }

        try {
            const res = await axios.post(API_ENDPOINT.rfq_chat, formData, {
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            if (res?.data?.response == "Message sent.") {
                setSuccessPopUp(true)
                setUserPopupHeroText("Message Sent Successfully!!")
            }

        } catch (error) {
            console.error("Error:", error.response?.data || error.message);
        }

    };



    const vendorMessageHeader = (
        <HeaderTitle
            titleText={"Send Message" || <MoreHoriz sx={{ fontSize: "30px" }} />}
            customclass={classes.heading_pop_pup}
        />
    );

    const vendorTextArea = [
        <div>
            <p className={classes.heading_sub_text}>Please enter your message</p>
            <TextArea
                maxLength="2000"
                style={{ width: "100 %" }}
                title="send_message"
                name="send_message"
                rows={7}
                value={vendormessage.send_message}
                placeholder="Type your message here..."
                onChange={handleWordCount}
            />
            {charsLeft === 2000 && (
                <p className={classes.error_msg}>
                    Message should be less than 2000 characters only
                </p>
            )}
            {errorMessages ? (
                <p className={classes.error_msg}>Please fill above message field</p>
            ) : (
                ""
            )}
            <Attachment
                msg_file={getvendorfileupload}
                handleFileChange={handleuserFileChange}
                handleRemoveFile={handleUserRemoveFile}
            />
        </div>,
    ];

    const vendorActionBtn = [
        <DButtonOutlined
            label={"Cancel"}
            onClick={handleVendorMessageClosePopup}
            btnWidth={"17rem"}
            btnHeight={"4rem"}
        />,
        <DButton
            label={sendbtntext && !errorMessages ? "Sending" : "Send Message"}
            btnWidth={"17rem"}
            btnHeight={"4rem"}
            onClick={handleSendVendorMessage}
        //   disabled={sendmsg && !errorMessages}
        />,
    ];
const normalizeItemTokenList = (tokens) => {
  if (!tokens) return [];
  if (Array.isArray(tokens)) return tokens.map((t) => String(t || "").trim()).filter(Boolean);
  const single = String(tokens || "").trim();
  return single ? [single] : [];
};

const getVendorsByCategory = async (item_token) => {
  const normalizedTokens = normalizeItemTokenList(item_token);
  if (normalizedTokens.length === 0) return;
  vendorFilterActiveRef.current = true;

  try {
    const fetchForToken = async (token) => {
      const res = await axios.post(
        API_ENDPOINT.vendors_by_category,
        {
          organization_token,
          item_token: token,
        },
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        }
      );
      const vendors = Array.isArray(res?.data?.vendors) ? res.data.vendors : [];
      const vendorContacts = Array.isArray(res?.data?.vendor_contacts)
        ? res.data.vendor_contacts
        : [];
      return { vendors, vendorContacts };
    };

    const results =
      normalizedTokens.length === 1
        ? [await fetchForToken(normalizedTokens[0])]
        : await Promise.all(normalizedTokens.map((t) => fetchForToken(t)));

    const vendors = results.flatMap((r) => r.vendors || []);
    const vendorContacts = results.flatMap((r) => r.vendorContacts || []);

    const normalizeVendorName = (value) =>
      String(value ?? "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();

    // Build lookup maps so we can prefer `vendor_contact_token` for selection + save payload
    const contactTokenByName = new Map();
    vendorContacts.forEach((v) => {
      const name = String(v?.vendor_contact_name || v?.vendor_name || v?.company_name || v?.name || "").trim();
      const contactToken = String(v?.vendor_contact_token || "").trim();
      if (!name || !contactToken) return;
      contactTokenByName.set(normalizeVendorName(name), contactToken);
    });

    const vendorMetaByName = new Map();
    vendors.forEach((v) => {
      const name = String(v?.vendor_name || v?.company_name || v?.name || "").trim();
      const vendorToken = String(v?.vendor_token || v?.token || v?.user_token || "").trim();
      const email = String(v?.company_official_email || v?.email || "").trim();
      if (!name) return;
      vendorMetaByName.set(normalizeVendorName(name), { vendorToken, email });
    });

    const shortToken = (token) => {
      const t = String(token || "").trim();
      return t ? t.slice(0, 6) : "";
    };

    const fromVendors = (() => {
      const map = new Map();
      const full = {};
      vendors.forEach((v) => {
        const vendorToken = String(v?.vendor_token || v?.token || v?.user_token || "").trim();
        if (!vendorToken) return;
        const name = String(v?.vendor_name || v?.company_name || v?.name || "").trim();
        const email = String(v?.vendor_email || v?.company_official_email || v?.email || "").trim();
        const contactToken = contactTokenByName.get(normalizeVendorName(name)) || "";
        const token = contactToken || vendorToken;
        const label = email
          ? `${name} (${email})`
          : token
            ? `${name} (${shortToken(token)})`
            : name;
        if (!label || !token) return;
        if (!map.has(token)) map.set(token, label);
        full[token] = {
          token,
          vendor_token: vendorToken,
          vendor_contact_token: contactToken,
          companyName: name,
          email,
          role: v?.role || "vendor",
        };
      });
      return {
        values: { tokens: Array.from(map.keys()), visibleOption: Array.from(map.values()) },
        fullDetails: full,
      };
    })();

    const fromContacts = (() => {
      const map = new Map();
      const full = {};
      vendorContacts.forEach((v) => {
        const name = String(v?.vendor_contact_name || v?.vendor_name || v?.company_name || v?.name || "").trim();
        const contactToken = String(v?.vendor_contact_token || "").trim();
        const vendorToken = String(v?.vendor_token || v?.token || "").trim();
        const meta = vendorMetaByName.get(normalizeVendorName(name)) || {};
        const email = String(
          v?.vendor_email ||
            v?.company_official_email ||
            v?.email ||
            meta.email ||
            ""
        ).trim();

        // Prefer vendor_contact_token for the "token" that ends up in vendorInfo
        const token = contactToken || vendorToken;
        // Label must be unique per option; otherwise identical labels cause "selecting one selects all".
        const label = email
          ? `${name} (${email})`
          : token
            ? `${name} (${shortToken(token)})`
            : name;
        if (!label || !token) return;
        if (!map.has(token)) map.set(token, label);
        full[token] = {
          token,
          vendor_token: meta.vendorToken || vendorToken,
          vendor_contact_token: contactToken,
          companyName: name,
          email,
          role: v?.role || "vendor",
        };
      });
      return {
        values: { tokens: Array.from(map.keys()), visibleOption: Array.from(map.values()) },
        fullDetails: full,
      };
    })();

    // Prefer the contact-token backed list when available (backend expects vendor_contact_token)
    const next = fromContacts.values.tokens.length ? fromContacts : fromVendors;
    setVendorsList(next);

  } catch (err) {
    console.error("Vendor filter failed", err);
    vendorFilterActiveRef.current = true;
    setVendorsList({
      values: { tokens: [], visibleOption: [] },
    });
  }
};

  const resetQuickRfqItemRow = (row = {}) => ({
    ...row,
    itemName: "",
    expenseType: "",
    itemCode: "",
    itemToken: "",
    hsnCode: "",
    unspscCode: "",
    category: "",
    subCategory: "",
    itemType: "",
    brand: "",
    partNumber: "",
    specifications: "",
    aliases: "",
    tax: "",
    gstList: [],
    itemDuplicate: false,
  });

  const resolveQuickRfqItemValue = (itemData, keys = []) => {
    for (const key of keys) {
      const value = itemData?.[key];
      if (value === undefined || value === null) continue;
      if (typeof value === "object") {
        const nested =
          value?.name ??
          value?.label ??
          value?.value ??
          value?.code ??
          "";
        if (String(nested).trim() !== "") return String(nested).trim();
        continue;
      }
      if (String(value).trim() !== "") return String(value).trim();
    }
    return "";
  };

  const normalizeQuickRfqCode = (value) => {
    const raw = resolveQuickRfqItemValue({ value }, ["value"]);
    if (!raw) return "";
    return raw.includes("-") ? raw.split("-")[0].trim() : raw;
  };

  const applyItemDataToQuickRfqRow = (row = {}, itemData) => {
    if (!itemData) return resetQuickRfqItemRow(row);

    const resolvedExpenseType = resolveQuickRfqItemValue(itemData, [
      "expense_type",
      "expenseType",
      "expense_type_name",
      "expenseTypeName",
      "expense_type_label",
      "expenseTypeLabel",
    ]);

    const resolvedHsnCode = normalizeQuickRfqCode(
      resolveQuickRfqItemValue(itemData, ["hsn_code", "hsnCode", "hsn"]),
    );

    const resolvedUnspscCode = normalizeQuickRfqCode(
      resolveQuickRfqItemValue(itemData, ["unspsc_code", "unspscCode", "unspsc"]),
    );

    return {
      ...row,
      itemName: resolveQuickRfqItemValue(itemData, ["item_name", "itemName", "name"]),
      expenseType: resolvedExpenseType,
      itemCode: resolveQuickRfqItemValue(itemData, ["item_code", "itemCode", "code"]),
      itemToken: resolveQuickRfqItemValue(itemData, ["token", "item_token", "itemToken"]),
      hsnCode: resolvedHsnCode,
      unspscCode: resolvedUnspscCode,
      unit: resolveQuickRfqItemValue(itemData, ["uom", "unit"]),
      description: resolveQuickRfqItemValue(itemData, ["item_description", "description"]),
      category: resolveQuickRfqItemValue(itemData, ["category"]),
      subCategory: resolveQuickRfqItemValue(itemData, ["sub_category", "subCategory"]),
      itemType: resolveQuickRfqItemValue(itemData, ["item_type", "itemType"]),
      brand: resolveQuickRfqItemValue(itemData, ["brand"]),
      partNumber: resolveQuickRfqItemValue(itemData, ["manufacturer_part_no", "part_number"]),
      specifications: resolveQuickRfqItemValue(itemData, ["specifications"]),
      aliases: resolveQuickRfqItemValue(itemData, ["aliases"]),
      tax: Array.isArray(itemData?.GST_list)
        ? itemData.GST_list.map((tax) => `${tax?.country || ""}${tax?.country && tax?.gst ? " - " : ""}${tax?.gst || ""}${tax?.gst ? "%" : ""}`).filter(Boolean).join(", ")
        : "",
      gstList: Array.isArray(itemData?.GST_list) ? itemData.GST_list : [],
      itemDuplicate: false,
    };
  };

  const handleItemSelection = async (index, selectedItem) => {
    const updatedItems = [...(items || [])];
    if (!selectedItem) {
      updatedItems[index] = resetQuickRfqItemRow(updatedItems[index]);
      const next = clearResolvedQuickDuplicateFlags(updatedItems);
      setItems(next);
      const tokens = (next || []).map((i) => i?.itemToken).filter(Boolean);
      if (tokens.length === 0) {
        clearVendorsForNoItem();
      } else {
        void getVendorsByCategory(tokens);
      }
      return;
    }
    const itemData = getItemMaster.find(
        (item) => item.item_name === selectedItem
    );

    if (itemData) {
        updatedItems[index] = applyItemDataToQuickRfqRow(updatedItems[index], itemData);

        // ✅ IMPORTANT — Fetch vendors based on category
        // vendor list will be filtered from selected item(s) below
    }

    const next = markQuickDuplicateForIndexOnly(updatedItems, index);
    setItems(next);
    const tokens = (next || []).map((i) => i?.itemToken).filter(Boolean);
    if (tokens.length > 0) {
      void getVendorsByCategory(tokens);
    }

    if (next.some((i) => i.itemDuplicate)) {
      setPrimaryBtnError({ error: true, errorMsg: "Item already added" });
    } else if (primaryBtnError?.errorMsg?.includes("Item already added")) {
      setPrimaryBtnError({ error: false, errorMsg: "" });
    }
};

  const handleItemCodeSelection = async (index, selectedCode) => {
    const updatedItems = [...(items || [])];
    if (!selectedCode) {
      updatedItems[index] = resetQuickRfqItemRow(updatedItems[index]);
      const next = clearResolvedQuickDuplicateFlags(updatedItems);
      setItems(next);
      const tokens = (next || []).map((i) => i?.itemToken).filter(Boolean);
      if (tokens.length === 0) {
        clearVendorsForNoItem();
      } else {
        void getVendorsByCategory(tokens);
      }
      return;
    }

    const itemData = getItemMaster.find((item) => item.item_code === selectedCode);
    updatedItems[index] = itemData
      ? applyItemDataToQuickRfqRow(updatedItems[index], itemData)
      : {
          ...resetQuickRfqItemRow(updatedItems[index]),
          itemCode: selectedCode,
        };

    const next = markQuickDuplicateForIndexOnly(updatedItems, index);
    setItems(next);
    const tokens = (next || []).map((i) => i?.itemToken).filter(Boolean);
    if (tokens.length > 0) {
      void getVendorsByCategory(tokens);
    }

    if (next.some((i) => i.itemDuplicate)) {
      setPrimaryBtnError({ error: true, errorMsg: "Item already added" });
    } else if (primaryBtnError?.errorMsg?.includes("Item already added")) {
      setPrimaryBtnError({ error: false, errorMsg: "" });
    }
  };


    const handleAddressSelection = (items) => {
        setSelectedAddress(items)
    }

    const getQuickRfqUploadExtension = (file) =>
        String(file?.name || "")
            .split(".")
            .pop()
            ?.toLowerCase() || "";

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const extension = getQuickRfqUploadExtension(file);
        if (!QUICK_RFQ_ALLOWED_EXTENSIONS.includes(extension)) {
            setFileUpload(null);
            if (event?.target) {
                event.target.value = "";
            }
            setQuickRfqSubmitError({
                field: "xls",
                message: "Please upload a valid CSV or Excel file (.csv, .xls, .xlsx).",
            });
            return;
        }

        setFileUpload(file);
        if (quickRfqSubmitError.field === "xls") {
            setQuickRfqSubmitError({ field: "", message: "" });
        }
        void applyVendorFilterFromUploadedFile(file);
    };


    const handleDragOver = (event) => {
        event.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = (event) => {
        event.preventDefault();
        setDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setDragging(false);
        const file = event.dataTransfer.files[0];
        if (!file) return;

        const extension = getQuickRfqUploadExtension(file);
        if (!QUICK_RFQ_ALLOWED_EXTENSIONS.includes(extension)) {
            setFileUpload(null);
            setQuickRfqSubmitError({
                field: "xls",
                message: "Please upload a valid CSV or Excel file (.csv, .xls, .xlsx).",
            });
            return;
        }

        setFileUpload(file);
        if (quickRfqSubmitError.field === "xls") {
            setQuickRfqSubmitError({ field: "", message: "" });
        }
        void applyVendorFilterFromUploadedFile(file);
    };

    // const handleQuickRFQSave = async () => {


    //     let transformedData = {}
    //     org_details.forEach(item => {
    //         transformedData[item.label] = item.value
    //     })

    //     let finalData = {
    //         ...transformedData,
    //         purchase_request_number: prNumber
    //     };


    //     let newlyAddedVendors = vendor.value.filter(vendorItem =>
    //         !vendorsList.values.visibleOption.includes(vendorItem)
    //     );

    //     let transformedVendor = newlyAddedVendors.map(vendorItem =>
    //         vendorItem.replace(/(.*?)\s\((.*?)\)/, "$1|$2")
    //     );


    //     let finaVendorData = {
    //         buyer_token: buyer_token,
    //         vendor_details: transformedVendor
    //     }

    //     console.log(finaVendorData)

    //     const res = await axios.post(API_ENDPOINT.rfq_add_new_vendor, finaVendorData, {
    //         headers: {
    //             Authorization: `Bearer ${auth_token}`,
    //             "Content-Type": "application/json",
    //         },
    //     });

    //     const newVendors = res?.data?.response.map(vendor => ({
    //         token: vendor.token,
    //         companyName: vendor.company_name,
    //         email: vendor.company_official_email
    //     })) || [];

    //     const vendorInfo = [
    //         ...vendor.fullDetails.map(({ token, companyName, email }) => ({
    //             token,
    //             companyName,
    //             email
    //         })),
    //         ...newVendors
    //     ];

    //     const formData = {
    //         user_token,
    //         items,
    //         ...finalData,
    //         ...selectedaddress,
    //         vendorInfo,
    //         bid_from_date: bidstartdate.utc().format("YYYY-MM-DDT00:00:00.000000[Z]"),
    //         bid_to_date: bidenddate.utc().format("YYYY-MM-DDT00:00:00.000000[Z]"),
    //         bid_time: bidendtime.utc().hour(11).minute(59).second(0).millisecond(0).format("YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]")
    //     }

    //     console.log(formData)

    //     const saverfq = await axios.post(API_ENDPOINT.save_quick_rfq, formData, {
    //         headers: {
    //             Authorization: `Bearer ${auth_token}`,
    //             "Content-Type": "application/json",
    //         },
    //     });


    //     if (saverfq?.status == 200) {
    //         setSuccessPopUp(true);
    //         setSavedRFQToken(saverfq?.data)
    //         setUserPopupHeroText(saverfq?.data?.response)
    //         sendNewRFQToken(saverfq?.data?.rfq_token)

    //     }

    // };




    const handleQuickRFQSave = async () => {
        const scrollToRef = (ref) => {
            const node = ref?.current;
            if (node && typeof node.scrollIntoView === "function") {
                node.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        };

        const failSubmit = (field, message) => {
            setQuickRfqSubmitError({ field, message });
            if (field === "xls") {
                scrollToRef(xlsUploadRef);
                if (xlsFileInputRef?.current) {
                    try {
                        xlsFileInputRef.current.focus();
                    } catch {}
                }
                return;
            }
            if (field === "manual") {
                scrollToRef(manualItemsRef);
                return;
            }
            if (field === "prNumber") {
                scrollToRef(prNumberRef);
                if (prNumberInputRef?.current) {
                    try {
                        prNumberInputRef.current.focus();
                    } catch {}
                }
            }
        };

        setQuickRfqSubmitError({ field: "", message: "" });

        let transformedData = {};
        org_details.forEach((item) => {
            transformedData[item.label] = item.value;
        });

        const resolvedRfqCode = String(
            transformedData["RFQ Code"] ?? transformedData["RFQ ID"] ?? "",
        ).trim();

        let finalData = {
            ...transformedData,
            "RFQ Code": resolvedRfqCode,
            purchase_request_number: prNumber,
        };

        if (!resolvedRfqCode) {
            failSubmit("rfqCode", "RFQ ID is missing. Please refresh and try again.");
            return;
        }

        const normalizedPrNumber = String(prNumber || "").trim();
        if (!normalizedPrNumber) {
            failSubmit("prNumber", "Please enter Purchase Requisition Number.");
            return;
        }
        if (!/^[A-Za-z0-9/_-]{1,10}$/.test(normalizedPrNumber)) {
            failSubmit(
                "prNumber",
                "Purchase Requisition Number must be max 10 characters and can contain only letters, numbers, /, _ and -.",
            );
            return;
        }

        if (inputMethod === "manual") {
            if (hasAnyQuickDuplicates(items || [])) {
                const nextItems = markLatestQuickDuplicatesForSubmit(items || []);
                setItems(nextItems);
                setPrimaryBtnError({
                    error: true,
                    errorMsg: "Item already added. Remove the duplicate item to continue.",
                });
                return;
            }
        }

        if (inputMethod === "manual") {
            if (!Array.isArray(items) || items.length === 0) {
                failSubmit("manual", "Please add at least one item under 'Type details of RFQ'.");
                return;
            }

            const invalid = (items || []).reduce((acc, it, idx) => {
                if (acc) return acc;
                const nameOk = String(it?.itemName || "").trim().length > 0;
                const unitOk = String(it?.unit || "").trim().length > 0;
                const qtyOk = String(it?.quantity || "").trim().length > 0;
                if (nameOk && unitOk && qtyOk) return acc;
                const missing = [];
                if (!nameOk) missing.push("Item Name");
                if (!unitOk) missing.push("Unit");
                if (!qtyOk) missing.push("Quantity");
                return { index: idx, missing };
            }, null);

            if (invalid) {
                failSubmit(
                    "manual",
                    `Please fill ${invalid.missing.join(", ")} for item ${invalid.index + 1}.`,
                );
                return;
            }
        } else if (inputMethod === "xls") {
            if (!fileUpload) {
                failSubmit("xls", "Please attach RFQ document (CSV/Excel) to continue.");
                return;
            }
        }

        // ✅ Ensure Vendor Data is Properly Structured
        const normalizeVendorLabel = (label) =>
            String(label ?? "")
                .replace(/\s+/g, " ")
                .trim();

        const parseVendorLabel = (label) => {
            const normalized = normalizeVendorLabel(label);
            const m = normalized.match(/^(.*)\((.*)\)$/);
            if (!m) return { companyName: normalized, email: "" };
            return {
                companyName: normalizeVendorLabel(m[1]),
                email: normalizeVendorLabel(m[2]),
            };
        };

        const lookupToken = (companyName, email) => {
            const pool = [
                ...(Object.values(vendorsList?.fullDetails || {}) || []),
                ...(Object.values(allVendorsList?.fullDetails || {}) || []),
            ];
            const nameKey = normalizeVendorLabel(companyName).toLowerCase();
            const emailKey = normalizeVendorLabel(email).toLowerCase();
            const found = pool.find((v) => {
                const n = normalizeVendorLabel(v?.companyName).toLowerCase();
                const e = normalizeVendorLabel(v?.email).toLowerCase();
                if (!n) return false;
                if (emailKey) return n === nameKey && e === emailKey;
                return n === nameKey;
            });
            return found?.token || "";
        };

        let vendorInfoArray = [];
        if (!isFreeRfq) {
            const fullDetailsList = Array.isArray(vendor?.fullDetails)
                ? vendor.fullDetails
                : vendor?.fullDetails && typeof vendor.fullDetails === "object"
                      ? Object.values(vendor.fullDetails)
                      : [];

            vendorInfoArray = (fullDetailsList || [])
                .map((vendorItem) => {
                    const vendorContactToken = String(
                        vendorItem?.vendor_contact_token ||
                            vendorItem?.vendorContactToken ||
                            vendorItem?.vendor_contactToken ||
                            "",
                    ).trim();
                    const vendorToken = String(
                        vendorItem?.vendor_token ||
                            vendorItem?.vendorToken ||
                            "",
                    ).trim();
                    const token = String(vendorItem?.token || "").trim();
                    const companyName = String(vendorItem?.companyName || vendorItem?.vendor_name || "").trim();
                    const email = String(vendorItem?.email || "").trim();

                    // Backend expects vendor_contact_token (fall back to whatever token we have)
                    const primaryToken = vendorContactToken || token || vendorToken;
                    return {
                        token: primaryToken,
                        vendor_contact_token: vendorContactToken || primaryToken,
                        vendor_token: vendorToken,
                        vendor_name: companyName,
                        companyName,
                        email,
                    };
                })
                .filter((v) => v.companyName || v.email || v.token);

            // Fallback: when vendor.fullDetails isn't populated (e.g. "Add Vendor" flow),
            // derive company/email/token from the selected labels.
            if (vendorInfoArray.length === 0 && Array.isArray(vendor?.value) && vendor.value.length > 0) {
                const seen = new Set();
                vendorInfoArray = vendor.value
                    .map((label) => {
                        const { companyName, email } = parseVendorLabel(label);
                        const token = lookupToken(companyName, email);
                        const key = token || `${companyName}::${email}`.toLowerCase();
                        if (seen.has(key)) return null;
                        seen.add(key);
                        return {
                            token,
                            vendor_contact_token: token,
                            vendor_token: "",
                            vendor_name: companyName,
                            companyName,
                            email,
                        };
                    })
                    .filter(Boolean);
            }
        }

        let formData = new FormData();

        formData.append("user_token", user_token);
        formData.append("RFQ Code", resolvedRfqCode);
        formData.append("Bid Type", bidType);
        formData.append("Proposal Document", proposalDoc);
        formData.append("purchase_request_number", prNumber);
        formData.append("shipping_address1", selectedaddress?.shipping_address1 || "");
        formData.append("shipping_address2", selectedaddress?.shipping_address2 || "");
        formData.append("city", selectedaddress?.city || "");
        formData.append("state", selectedaddress?.state || "");
        formData.append("country", selectedaddress?.country || "");
        formData.append("mobile_number", selectedaddress?.mobile_number || "");
        formData.append("pincode", selectedaddress?.pincode || "");

        formData.append("bid_from_date", bidstartdate.utc().format("YYYY-MM-DDT00:00:00.000000[Z]"));
        formData.append("bid_to_date", bidenddate.utc().format("YYYY-MM-DDT00:00:00.000000[Z]"));
        formData.append(
            "bid_time",
            bidendtime.utc().format("YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]")
        );

        formData.append("vendorInfo", JSON.stringify(vendorInfoArray));
        if (isFreeRfq) {
            const freeRfqMobileNumbers = freeRfqRecipients
                .map((row) => String(row.mobile || "").trim())
                .filter(Boolean);
            const freeRfqEmails = freeRfqRecipients
                .map((row) => String(row.email || "").trim())
                .filter(Boolean);
            formData.append("free_rfq_mobile_number", freeRfqMobileNumbers.join(","));
            formData.append("free_rfq_email", freeRfqEmails.join(","));
        }

        if (inputMethod === "manual") {
            // Backend variants have historically accepted either camelCase or snake_case keys.
            // Send both to avoid null item_name issues across environments.
            const itemsPayload = (items || []).map((it) => {
                const itemName = it?.itemName ?? it?.item_name ?? "";
                const itemCode = it?.itemCode ?? it?.item_code ?? "";
                const itemToken = it?.itemToken ?? it?.item_token ?? "";
                const hsnCode = it?.hsnCode ?? it?.hsn_code ?? "";
                const unspscCode = it?.unspscCode ?? it?.unspsc_code ?? "";
                const unit = it?.unit ?? "";
                const quantity = it?.quantity ?? "";
                const description = it?.description ?? "";
                const expenseType = it?.expenseType ?? it?.expense_type ?? "";
                const category = it?.category ?? "";
                const subCategory = it?.subCategory ?? it?.sub_category ?? "";
                const itemType = it?.itemType ?? it?.item_type ?? "";
                const brand = it?.brand ?? "";
                const partNumber = it?.partNumber ?? it?.part_number ?? "";
                const specifications = it?.specifications ?? "";
                const aliases = it?.aliases ?? "";
                const gstList = it?.gstList ?? it?.GST_list ?? [];

                return {
                    // camelCase
                    itemName,
                    itemCode,
                    itemToken,
                    hsnCode,
                    unspscCode,
                    unit,
                    quantity,
                    description,
                    expenseType,
                    category,
                    subCategory,
                    itemType,
                    brand,
                    partNumber,
                    specifications,
                    aliases,
                    GST_list: gstList,
                    // snake_case
                    item_name: itemName,
                    item_code: itemCode,
                    item_token: itemToken,
                    hsn_code: hsnCode,
                    unspsc_code: unspscCode,
                    expense_type: expenseType,
                    sub_category: subCategory,
                    item_type: itemType,
                    part_number: partNumber,
                    gst_list: gstList,
                };
            });
            formData.append("items", JSON.stringify(itemsPayload));
        } else if (fileUpload) {
            formData.append("item_code_xlsx", fileUpload);
        }

        try {
            const response = await axios.post(API_ENDPOINT.save_quick_rfq, formData, {
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response?.status === 200) {
                setSuccessPopUp(true);
                setSavedRFQToken(response?.data);
                setUserPopupHeroText(response?.data?.response);
                sendNewRFQToken(response?.data?.rfq_token);
            }
        } catch (error) {
            console.error("Error saving RFQ:", error.response?.data || error.message);
        }
    };



    const sendNewRFQToken = async (token) => {
        await axios({
            method: "POST",
            url: `${API_ENDPOINT.rfq_newversion_chatgpt}`,
            data: {
                rfq_token: token,
                org_token: organization_token || org_token || buyer_token,
            },
            headers: {
                Authorization: `Bearer ${auth_token}`,
            },
        })
            .then((res) => {
                console.log(res);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const clearAllState = () => {
        setSuccessPopUp(false);
        setOpenModal(false)
        setMessageBtn(true)
        setFreeRfqRecipients([
            {
                mobile: "",
                email: "",
                mobileError: "",
                emailError: "",
                mobileValid: true,
                emailValid: true,
            },
        ]);
        if (typeof closeQuickRFQ === "function") {
            closeQuickRFQ();
        }
        const defaultPath = isFreeRfq ? "/Buyer_dashboard/FreeRFQ" : "/Buyer_dashboard/RFQ";
        if (location.pathname !== defaultPath) {
            navigate(defaultPath);
        }
    };



    // add vendor

    const getCompanyList = async (searchValue) => {
        let abortController = new AbortController();
        try {
            abortController.abort();

            const newAbortController = new AbortController();
            abortController = newAbortController;

            const formData = new FormData();
            formData.append("buyer_token", buyer_token);
            formData.append("search", searchValue);

            const response = await axios({
                method: "POST",
                url: `${API_ENDPOINT.getCompanyList}`,
                data: formData,
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
                signal: abortController.signal,
            });

            let responseData = response?.data?.response;
            setCompanyList(responseData?.map((e) => e?.company_name));
        } catch (error) {
            if (error.name === "AbortError") {
                console.log("Request aborted:", error.message);
            } else {
                console.log(error);
            }
        }
    };




    const vendorsTabInputs = [
        <DFreeSoloInput
            label="Company Name"
            value={CompanyName.value}
            options={companyList}
            onChange={(value) => {
                if (openaddvendor) {
                    setCompanyName({
                        value: value,
                        isValid: emptyCheck(value),
                    });
                }
                if (value?.length > 2) {
                    getCompanyList(value);
                } else {
                    setCompanyList([]);
                }
            }}
            error={!CompanyName.isValid}
            errorMsg={"Company name is required"}
            size={"100%"}
        />,
        <DTextInput
            label={"Email"}
            value={VendorRegisteredEmail.value}
            onChange={(e) => {
                let val = e.target.value;
                const arr = [];
                vendorId.forEach((item, i) => {
                    if (item === undefined) {
                        //extracting mail id from vendor
                        arr.push(vendor.value[i]?.split("(")[1]?.replace(")", ""));
                    }
                });
                //checking if the vendor mail exists
                if (arr.some((item) => item === val)) {
                    setVendorRegisteredEmail({
                        value: val,
                        isValid: false,
                        message: "vendor already selected",
                    });
                } else {
                    setVendorRegisteredEmail({
                        value: val,
                        isValid: validateEmail(val),
                    });
                }
            }}
            error={!VendorRegisteredEmail.isValid}
            errorMsg={
                !emptyCheck(VendorRegisteredEmail.value)
                    ? "Email is required"
                    : VendorRegisteredEmail?.message
                        ? VendorRegisteredEmail?.message
                        : !VendorRegisteredEmail.isValid
                            ? "Invalid email format"
                            : "" || ""
            }
            customClassName={vendorClasses.addVendorPopupInput}
            size={"100%"}
        />,
    ];

    const vendorsTabHeading = (
        <HeaderTitle
            titleText={"Add Supplier"}
            customclass={vendorClasses.popupHeading}
        />
    );

    const handleAddNewVendor = (e) => {
        e.stopPropagation();

        const isEmailValid = validateEmail(VendorRegisteredEmail.value);
        const isCompanyValid = emptyCheck(CompanyName.value);

        setCompanyName((prev) => ({ ...prev, isValid: isCompanyValid }));
        setVendorRegisteredEmail((prev) => ({ ...prev, isValid: isEmailValid }));

        if (isEmailValid && isCompanyValid) {
            setLoading(true);
            axios({
                method: "POST",
                url: `${API_ENDPOINT.rfq_vendor_email_verification}`,
                data: {
                    email: VendorRegisteredEmail.value,
                    buyer_token: buyer_token,
                },
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            })
                .then((response) => {
                    if (response.status === 200) {
                        const verifiedToken = String(
                            response?.data?.token ||
                                response?.data?.vendor_token ||
                                response?.data?.vendorToken ||
                                response?.data?.user_token ||
                                response?.data?.userToken ||
                                response?.data?.vendor_contact_token ||
                                "",
                        ).trim();

                        const companyName = String(CompanyName.value || "").trim();
                        const email = String(VendorRegisteredEmail.value || "").trim();
                        const label = email ? `${companyName} (${email})` : companyName;

                        setVendor((prev) => ({
                            ...prev,
                            isValid: true,
                            value: [...(prev.value || []), label],
                            fullDetails: (() => {
                                const prevDetails = Array.isArray(prev?.fullDetails)
                                    ? prev.fullDetails
                                    : [];
                                const nextDetails = [...prevDetails];
                                const emailKey = email.toLowerCase();
                                const exists = nextDetails.some((v) => {
                                    const t = String(v?.token || "").trim();
                                    const e = String(v?.email || "").trim().toLowerCase();
                                    if (verifiedToken && t && t === verifiedToken) return true;
                                    if (emailKey && e && e === emailKey) return true;
                                    return false;
                                });
                                if (!exists) {
                                    nextDetails.push({
                                        token: verifiedToken,
                                        companyName,
                                        email,
                                        role: "vendor",
                                    });
                                }
                                return nextDetails;
                            })(),
                        }));
                    }
                    handleClose1();
                    setLoading(false);
                })
                .catch((e) => {
                    setVendorRegisteredEmail((prev) => ({
                        ...prev,
                        message: e.response.data.response,
                        isValid: false,
                    }));
                    setLoading(false);
                });
        }
    };


    // const handleAddNewVendor = async (e) => {
    //     e.stopPropagation();

    //     const isEmailValid = validateEmail(VendorRegisteredEmail.value);
    //     const isCompanyValid = emptyCheck(CompanyName.value);

    //     setCompanyName((prev) => ({ ...prev, isValid: isCompanyValid }));
    //     setVendorRegisteredEmail((prev) => ({ ...prev, isValid: isEmailValid }));

    //     if (isEmailValid && isCompanyValid) {
    //         setLoading(true);
    //         try {
    //             const response = await axios.post(
    //                 `${API_ENDPOINT.rfq_vendor_email_verification}`,
    //                 {
    //                     email: VendorRegisteredEmail.value,
    //                     buyer_token: buyer_token,
    //                 },
    //                 { headers: { Authorization: `Bearer ${auth_token}` } }
    //             );

    //             console.log(response)

    //             if (response.status === 200) {
    //                 const newVendor = {
    //                     token: response.data.token,
    //                     companyName: CompanyName.value,
    //                     email: VendorRegisteredEmail.value,
    //                     role: "vendor", // Assuming role is "vendor"
    //                 };

    //                 // ✅ Update vendor list to include the new vendor
    //                 setVendorsList((prev) => ({
    //                     values: {
    //                         tokens: [...prev.values.tokens, newVendor.token],
    //                         visibleOption: [
    //                             ...prev.values.visibleOption,
    //                             `${newVendor.companyName} (${newVendor.email})`,
    //                         ],
    //                     },
    //                     fullDetails: {
    //                         ...prev.fullDetails,
    //                         [newVendor.token]: newVendor,
    //                     },
    //                 }));

    //                 // ✅ Add new vendor to the selected vendors
    //                 setVendor((prev) => ({
    //                     ...prev,
    //                     value: [
    //                         ...prev.value,
    //                         `${newVendor.companyName} (${newVendor.email})`,
    //                     ],
    //                     fullDetails: [...prev.fullDetails, newVendor], // Add new vendor to details list
    //                     isValid: true,
    //                 }));
    //             }

    //             handleClose1();
    //         } catch (e) {
    //             setVendorRegisteredEmail((prev) => ({
    //                 ...prev,
    //                 message: e.response.data.response,
    //                 isValid: false,
    //             }));
    //         } finally {
    //             setLoading(false);
    //         }
    //     }
    // };


    const handleOpen1 = () => setOpenAddVendor(true);

    const handleClose1 = () => {
        setOpenAddVendor(false);
        setVendorRegisteredEmail({
            value: "",
            errorMsg: "",
            isValid: true,
        });
        setCompanyName({
            value: "",
            errorMsg: "",
            isValid: true,
        });
    };

    const popupActions = [
        <DButtonOutlined
            label={"Cancel"}
            onClick={handleClose1}
            btnWidth={"17rem"}
            btnHeight={"4rem"}
            buyerBtn={true}
        />,
        <DButton
            label={"Add"}
            btnWidth={"17rem"}
            btnHeight={"4rem"}
            buyerBtn={true}
            error={primaryBtnError.error}
            errorMsg={primaryBtnError.errorMsg}
            loadingState={loading}
            onClick={handleAddNewVendor}
        />,
    ];

    const handleNavigate = () => {
        if (typeof closeQuickRFQ === "function") {
            closeQuickRFQ();
            return;
        }
        navigate(isFreeRfq ? "/Buyer_dashboard/FreeRFQ" : "/Buyer_dashboard/RFQ");
    }

    const isRFQPage = location.pathname === (isFreeRfq ? "/Buyer_dashboard/FreeRFQ" : "/Buyer_dashboard/RFQ");

    const isMobileValid = (value) => {
        const normalized = String(value || "").replace(/\D/g, "");
        return normalized.length >= 10 && normalized.length <= 15;
    };

    const handleSendFreeRfqLink = async () => {
        const validation = validateFreeRfqRecipients(freeRfqRecipients);
        setFreeRfqRecipients(validation.rows);

        if (!validation.canSend) return;

        const mobileNumbers = validation.rows.map((row) => String(row.mobile || "").trim()).filter(Boolean);
        const emails = validation.rows.map((row) => String(row.email || "").trim()).filter(Boolean);

        setLoading(true);
        try {
            const response = await axios({
                method: "POST",
                url: `${API_ENDPOINT.rfq_vendor_email_verification}`,
                data: {
                    email: emails.join(","),
                    mobile_number: mobileNumbers.join(","),
                    buyer_token,
                },
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            });

            if (response?.status === 200) {
                setSuccessPopUp(true);
                setUserPopupHeroText(response?.data?.response || "easyRFQ link sent successfully");
            }
        } catch (error) {
            setPrimaryBtnError({
                error: true,
                errorMsg: error?.response?.data?.response || "Unable to send link",
            });
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className={classes.quickRfqCreateScreen}>

            {!isRFQPage && (
                <div className={classes.quickRfqCreateHeader}>
                    <div>
                        <h1>{isFreeRfq ? "easyRFQ" : "Xpress RFQ"}</h1>
                        <p>Create and send a Request for Quotation</p>
                    </div>
                    <DButton
                        label="BACK"
                        btnHeight="4rem"
                        btnWidth="12rem"
                        buyerBtn={true}
                        onClick={handleNavigate}
                    />
                </div>
            )}

            {/* <HeaderTitle titleText={"Quick RFQ"}/> */}

            <div className={`${classes.quickrfqinfo} ${classes.quickRfqCreateSection}`}>

                <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "flex-start" }}>

                    {org_details.map((e, i) => (
                        <InfoLabel
                            key={i}
                            label={e.label}
                            value={e.value}
                            size={e.size}
                        />
                    ))}

                    <div className={classes.bidtype}>
                        <p>Bid Type <span className={classes.requiredMark}>*</span></p>
                        <RadioGroup
                            row
                            value={bidType}
                            onChange={(e) => {
                                console.log(e.target.value)
                                setBidType(e.target.value)}}
                        >
                        <FormControlLabel value="1" control={<Radio />} label="Auction" sx={{ "& .MuiTypography-root": { fontSize: "14px", fontFamily: "gilroyMedium, gilroyRegular, sans-serif" } }} />
                        <FormControlLabel value="0" control={<Radio />} label="Closed" sx={{ "& .MuiTypography-root": { fontSize: "14px", fontFamily: "gilroyMedium, gilroyRegular, sans-serif" } }} />
                        </RadioGroup>
                    </div>
                </div>

            </div>

            <div className={`${classes.detailscontainer} ${classes.quickRfqCreateSection}`}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className={classes.datewrapper}>
                        <label>Start Date <span className={classes.requiredMark}>*</span></label>
                        <DatePicker
                            format="DD/MM/YYYY"
                            value={bidstartdate}
                            disablePast
                            minDate={dayjs()}
                            onChange={(newValue) => {
                                setBidStartDate(newValue ? dayjs(newValue).utc() : null);
                                setBidEndDate(null);
                            }}
                            sx={{
                                "& .MuiInputBase-input": { fontSize: "14px", color: "#333", fontFamily: "gilroyMedium, gilroyRegular, sans-serif" }
                            }}
                            renderInput={(params) => <TextField {...params} className="border p-2 rounded" inputProps={{ ...params.inputProps, style: { fontFamily: "gilroyMedium, gilroyRegular, sans-serif" } }} />}
                        />
                    </div>
                    <div className={classes.datewrapper} >
                        <label>End Date <span className={classes.requiredMark}>*</span></label>

                        <DatePicker
                            format="DD/MM/YYYY"
                            value={bidenddate}
                            disablePast
                            minDate={bidstartdate || dayjs()}
                            onChange={(newValue) => setBidEndDate(newValue)}
                            sx={{
                                "& .MuiInputBase-input": { fontSize: "14px", color: "#333", fontFamily: "gilroyMedium, gilroyRegular, sans-serif" }
                            }}
                            renderInput={(params) => <TextField {...params} className="border p-2 rounded" inputProps={{ ...params.inputProps, style: { fontFamily: "gilroyMedium, gilroyRegular, sans-serif" } }} />}
                        />
                    </div>
                    <div className={classes.datewrapper}>
                        <label>End Time <span className={classes.requiredMark}>*</span></label>

                        <MobileTimePicker
                            value={bidendtime}
                            sx={{
                                "& .MuiInputBase-input": { fontSize: "14px", color: "#333", fontFamily: "gilroyMedium, gilroyRegular, sans-serif" }
                            }}
                            onChange={(newValue) => {
                                const updatedTime = dayjs(bidenddate)
                                    .hour(newValue.hour())
                                    .minute(newValue.minute())
                                    .second(0)
                                    .millisecond(0);
                                setBitEndTime(updatedTime); // Don't apply .utc() here
                            }}

                            renderInput={(params) => <TextField {...params} className="border p-2 rounded" inputProps={{ ...params.inputProps, style: { fontFamily: "gilroyMedium, gilroyRegular, sans-serif" } }} />}
                        />
                    </div>

                </LocalizationProvider>

                <div className={`${classes.datewrapper} ${classes.prNumberField}`} ref={prNumberRef}>
                    <label style={{ fontFamily: "gilroyMedium, gilroyRegular, sans-serif" }}>
                        Purchase Requisition Number <span className={classes.requiredMark}>*</span>
                    </label>
                    <input
                        ref={prNumberInputRef}
                        maxLength={10}
                        onChange={(e) => {
                            const raw = String(e.target.value ?? "");
                            const next = raw.replace(/[^A-Za-z0-9/_-]/g, "").slice(0, 10);
                            setPrNumber(next);
                            if (quickRfqSubmitError.field === "prNumber") {
                                setQuickRfqSubmitError({ field: "", message: "" });
                            }
                        }}
                        value={prNumber}
                        style={{ fontFamily: "gilroyMedium, gilroyRegular, sans-serif" }}
                        placeholder="Enter Purchase Requisition Number"
                    />
                    <div className={classes.fieldErrorSlot}>
                        {quickRfqSubmitError.field === "prNumber" && !!quickRfqSubmitError.message && (
                            <p className={classes.error_msg}>{quickRfqSubmitError.message}</p>
                        )}
                    </div>

                </div>
            </div>



            <div className={classes.quickRfqCreateSection}>
                <HeaderTitle titleText={"Items"} />

                <div>
                    <RadioGroup
                        row
                        value={inputMethod}
                        onChange={(e) => {
                            setInputMethod(e.target.value);
                            setQuickRfqSubmitError({ field: "", message: "" });
                        }}
                    >
                        <FormControlLabel value="xls" control={<Radio />} label="Attach RFQ document" sx={{ "& .MuiTypography-root": { fontSize: "14px", fontFamily: "gilroyMedium, gilroyRegular, sans-serif" } }} />
                        <FormControlLabel value="manual" control={<Radio />} label="Type details of RFQ" sx={{ "& .MuiTypography-root": { fontSize: "14px", fontFamily: "gilroyMedium, gilroyRegular, sans-serif" } }} />
                    </RadioGroup>
                    {(quickRfqSubmitError.field === "xls" || quickRfqSubmitError.field === "manual") &&
                        !!quickRfqSubmitError.message && (
                        <p className={classes.error_msg}>{quickRfqSubmitError.message}</p>
                    )}
                </div>



                {
                    inputMethod === 'xls' ?

                        <div className={classes.docField} ref={xlsUploadRef}>
                            <div
                                className={`${classes.fileUploadWrapper} ${dragging ? classes.drag_over : ""}`}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}>
                                <div className={classes.file_upload}>
                                    {/* <label>{fileUpload && fileUpload.name}</label> */}
                                    <label className={classes.DocText}>
                                        <span>{fileUpload ? fileUpload.name : "Drag and drop file here"}</span>
                                        <input ref={xlsFileInputRef} type="file" accept={QUICK_RFQ_UPLOAD_ACCEPT} style={{ display: "none" }} onChange={handleFileChange} />
                                        <p>(Supported format CSV/Excel)</p>
                                    </label>
                                    {!fileUpload ? (
                                        <button
                                            type="button"
                                            className={classes.browseButton}
                                            onClick={() => document.querySelector('input[type="file"]').click()}
                                        >
                                            Browse
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className={classes.clearButton}
                                            onClick={() => {
                                                setFileUpload(null);
                                                void applyVendorFilterFromUploadedFile(null);
                                            }}
                                        >
                                            Clear
                                        </button>
                                    )}
                                </div>
                                <span className={classes.sampleLinkWrap}>
                                    <p
                                        className={classes.linkBtn}
                                        onClick={() => {
                                            saveAs(RFQSampleItemsFile, "Sample CSV.csv");
                                        }}
                                    >
                                        Sample CSV
                                    </p>
                                </span>
                                {/* {fileUpload && (
                                    <div className={classes.fileInfo}>
                                        <span>{fileUpload.name} ({(fileUpload.size / 1024).toFixed(2)} KB)</span>
                                        <button onClick={() => setFileUpload(null)}>Remove</button>
                                    </div>
                                )} */}
                            </div>
                            {/* <input type="file" accept=".csv, .xlsx" onChange={handleFileChange} /> */}
                        </div>
                        :
                        <div className={classes.quickrfqTableWrap} ref={manualItemsRef}>
                        <table className={classes.quickrfq_table} style={{ display: "none" }}>
                            <thead>
                                <tr>
                                    <th>Item Name <span className={classes.requiredMark}>*</span></th>
                                    <th>Item Code</th>
                                    <th>Expense Type</th>
                                    <th>HSN Code</th>
                                    <th>UNSPSC Code</th>
                                    <th>Unit <span className={classes.requiredMark}>*</span></th>
                                    <th>Quantity <span className={classes.requiredMark}>*</span></th>
                                    <th>Description</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.length === 0 ? (
                                    <tr>
                                        <td colSpan={9} className={classes.quickrfqEmptyState}>
                                            No data found.
                                        </td>
                                    </tr>
                                ) : items.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <select
                                                value={item.itemName}
                                                onChange={(e) => handleItemSelection(index, e.target.value)}
                                            >
                                                <option value="">Select Item</option>
                                                {getItemMaster.map((itemOption) => (
                                                    <option key={itemOption.token} value={itemOption.item_name}>
                                                        {itemOption.item_name}
                                                    </option>
                                                ))}
                                            </select>
                                            {item.itemDuplicate && (
                                                <p className={classes.error_msg}>Item already added</p>
                                            )}
                                        </td>
                                        <td>
                                            <select
                                                value={item.itemCode}
                                                onChange={(e) => handleItemCodeSelection(index, e.target.value)}
                                            >
                                                <option value="">Select Item Code</option>
                                                {getItemMaster.map((itemOption) => (
                                                    <option key={itemOption.token} value={itemOption.item_code}>
                                                        {itemOption.item_code}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td><input type="text" value={item.expenseType || ""} readOnly /></td>
                                        {/* <Autocomplete
                                    options={getItemMaster}
                                    getOptionLabel={(option) => option.item_name}
                                    value={getItemMaster.find((itm) => itm.item_name === item.itemName) || null}
                                    onChange={(event, newValue) => handleItemSelection(index, newValue ? newValue.item_name : "")}
                                    renderInput={(params) => <TextField {...params} />}
                                /> */}
                                        <td><input type="text" value={item.hsnCode} readOnly /></td>
                                        <td><input type="text" value={item.unspscCode} readOnly /></td>
                                        <td>
                                            <select
                                                value={item.unit}
                                                onChange={(e) => handleInputChange(index, "unit", e.target.value)}
                                            >
                                                <option value="">Select Unit</option>
                                                {unitsOptions.map((unit, idx) => (
                                                    <option key={idx} value={unit}>
                                                        {unit}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                maxLength={10}
                                                value={item.quantity}
                                                onChange={(e) => handleInputChange(index, "quantity", e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (
                                                        e.key === "." ||
                                                        e.key === "-" ||
                                                        e.key === "+" ||
                                                        e.key === "e" ||
                                                        e.key === "E"
                                                    ) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                placeholder="Enter quantity"
                                            />
                                        </td>
                                        <td>
                                            <textarea
                                                className={classes.quickrfqDescription}
                                                value={item.description}
                                                onChange={(e) => handleInputChange(index, "description", e.target.value)}
                                                placeholder="Enter description"
                                                rows={3}
                                            />
                                        </td>
                                        <td className={classes.quickrfqActionCell}>
                                            <button
                                                type="button"
                                                className={classes.quickrfqRemoveBtn}
                                                onClick={() => removeItem(index)}
                                                aria-label="Remove item"
                                                title="Remove"
                                            >
                                                <DeleteOutlineIcon fontSize="medium" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className={`${classes.multiForm} ${classes.multiFormNoScroll}`}>
                            {items.map((item, index) => (
                                <div className={classes.items_form_wrapper} key={index}>
                                    <div className={classes.itemCount}><span>Item #{index + 1}</span></div>
                                    <div className={classes.input_fields_wrapper_multi_line1}>
                                        <DSelectInput customClass={classes.fields} label="Item Code" value={item.itemCode} options={getItemMaster.map((option) => option.item_code)} onChange={(value) => handleItemCodeSelection(index, value)} size="100%" />
                                        <DSelectInput customClass={classes.fields} label="Item Name" required={true} value={item.itemName} options={getItemMaster.map((option) => option.item_name)} onChange={(value) => handleItemSelection(index, value)} error={item.itemDuplicate} errorMsg="Item already added" size="100%" />
                                        <DTextInput customClassName={`${classes.fields} ${classes.rfqReadOnlyItemField}`} label="Expense Type" value={item.expenseType || ""} disabled={true} size="100%" />
                                    </div>
                                    <div className={classes.input_fields_wrapper_multi_line2}>
                                        <DTextInput customClassName={classes.fields} label="Quantity" required={true} maxLength={10} type="text" value={item.quantity} onChange={(e) => handleInputChange(index, "quantity", e.target.value)} size="100%" />
                                        <DSelectInput customClass={`${classes.fields} ${classes.rfqReadOnlyItemField}`} label="Unit" required={true} value={item.unit} options={unitsOptions} disabled={true} size="100%" />
                                        <DTextInput customClassName={`${classes.fields} ${classes.rfqReadOnlyItemField}`} label="Manufacturer Part Number" value={item.partNumber || ""} disabled={true} size="100%" />
                                    </div>
                                    <div className={classes.input_fields_wrapper_multi_line2}>
                                        {[["Category", item.category], ["Sub-category", item.subCategory], ["Item Type", item.itemType], ["HSN Code", item.hsnCode], ["UNSPSC Code", item.unspscCode], ["Brand", item.brand], ["Tax", item.tax], ["Specifications", item.specifications], ["Aliases", item.aliases]].map(([label, value]) => (
                                            <DTextInput key={label} customClassName={`${classes.fields} ${classes.rfqReadOnlyItemField}`} label={label} value={value || "-"} disabled={true} size="100%" />
                                        ))}
                                    </div>
                                    <DTextArea label="Item Description" required={true} placeholder="description" maxLength={2550} value={item.description} onChange={(e) => handleInputChange(index, "description", e.target.value)} containerClass={classes.itemDescription} customClassName={classes.itemDescriptionTextArea} inputWrapperClass={classes.textAreaWrapper} size="95.5%" />
                                    {index > 0 && <button type="button" className={classes.removeFormButton} onClick={() => removeItem(index)}>Remove</button>}
                                </div>
                            ))}
                        </div>
                        <div className={classes.quickrfqAddItemRow}>
                            <DButton
                                onClick={addNewItem}
                                label={"Add Items"}
                                btnWidth={"17rem"}
                                btnHeight={"4rem"}
                            />
                        </div>
                        </div>
                }
            </div>

            <div className={classes.quickRfqCreateSection}>

                <div>
                    <HeaderTitle titleText={"Shipping Address"} />
                    {/* <p>Add New Address</p> */}
                </div>

                <QuickRFQShippingAddress
                    addresses={address}
                    selectedAddress={selectedaddress}
                    onSelect={handleAddressSelection}
                    organizationName={org_name}
                    authToken={auth_token}
                    buyerToken={buyer_token}
                />

                {/* <div>
                    <div
                        className={`${classes.card} ${classes.addNewCard}`}
                        onClick={() => setOpenAddAddressModal(true)}
                    >
                        <h3>➕ Add New Address</h3>
                        <p>Click here to add a new shipping address</p>
                    </div>
                </div> */}

            </div>

            {isFreeRfq ? (
            <div className={`${classes.quickvendorselect} ${classes.quickRfqCreateSection}`}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
                    <HeaderTitle titleText={"Supplier Email ID or Mobile Number"} />
                    <IconButton
                        className={classes.freeRfqIconButton}
                        onClick={addFreeRfqRecipientRow}
                        aria-label="Add recipient"
                        size="small"
                    >
                        <AddCircleOutline sx={{ fontSize: 20 }} />
                    </IconButton>
                </div>
                    {primaryBtnError?.error && (
                        <p className={classes.error_msg} style={{ marginTop: 0 }}>
                            {primaryBtnError.errorMsg}
                        </p>
                    )}
                    <div className={classes.freeRfqRecipientRow}>
                        <div className={classes.freeRfqMobileColumn}>
                            <div className={classes.freeRfqRecipientList}>
                                {freeRfqRecipients.map((recipient, index) => (
                                    <div key={index} className={classes.freeRfqRecipientCard}>
                                        <div className={classes.freeRfqRecipientFields}>
                                            <DTextInput
                                                label={`Mobile Number ${index + 1}`}
                                                type="tel"
                                                maxLength={10}
                                                value={recipient.mobile}
                                                onChange={(e) =>
                                                    updateFreeRfqRecipient(index, "mobile", e.target.value)
                                                }
                                                error={freeRfqValidationAttempted && !recipient.mobileValid}
                                                errorMsg={recipient.mobileError || "Enter a valid 10 digit mobile number"}
                                                size={"100%"}
                                            />
                                            <DTextInput
                                                label={`Email ${index + 1}`}
                                                required={true}
                                                type="email"
                                                value={recipient.email}
                                                onChange={(e) =>
                                                    updateFreeRfqRecipient(index, "email", e.target.value)
                                                }
                                                error={freeRfqValidationAttempted && !recipient.emailValid}
                                                errorMsg={recipient.emailError || "Enter a valid email address"}
                                                size={"100%"}
                                            />
                                        </div>
                                        <div className={classes.freeRfqRecipientActions}>
                                            {freeRfqRecipients.length > 1 && (
                                                <IconButton
                                                    className={`${classes.freeRfqIconButton} ${classes.freeRfqRemoveButton}`}
                                                    onClick={() => removeFreeRfqRecipientRow(index)}
                                                    aria-label="Remove recipient"
                                                    size="small"
                                                >
                                                    <RemoveCircleOutline sx={{ fontSize: 20 }} />
                                                </IconButton>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className={classes.freeRfqSendLinkAction}>
                                <div
                                    style={{
                                        width: "100%",
                                        pointerEvents: isFreeRfqReadyToSend && !loading ? "auto" : "none",
                                        opacity: isFreeRfqReadyToSend && !loading ? 1 : 0.55,
                                        justifyContent: "flex-end",
                                    }}
                                >
                                <DButton
                                    label={"Send Link"}
                                    btnWidth={"100%"}
                                    btnHeight={"4rem"}
                                    buyerBtn={true}
                                    loadingState={loading}
                                    onClick={handleFreeRfqSendInvite}
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                    {!!freeRfqRecipientError && (
                        <p className={classes.error_msg} style={{ marginTop: "0.8rem" }}>
                            {freeRfqRecipientError}
                        </p>
                    )}
                </div>
            ) : (
                <>
                    <HeaderTitle titleText={"Supplier"} />
                    <div className={`${classes.quickvendorselect} ${classes.quickRfqCreateSection}`}>
                        <DSelectInput
                            customClass={`${classes.fields} ${classes.compactField}`}
                            multiselect={true}
                            label="Select Supplier"
                            required={true}
                            value={vendor.value}
                            options={vendorsList.values}
                            setIDValue={setVendorID}
                            onChange={(selectedValues) => {
                                const fullDetails = vendorsList?.fullDetails || {};
                                const vendorObjs = Object.values(fullDetails);

                                const normalizeLabel = (label) =>
                                    String(label ?? "")
                                        .replace(/\s+/g, " ")
                                        .trim();

                                const labelForVendor = (v) => {
                                    const name = String(v?.companyName || "").trim();
                                    const email = String(v?.email || "").trim();
                                    const t = String(v?.token || "").trim();
                                    return email ? `${name} (${email})` : t ? `${name} (${t.slice(0, 6)})` : name;
                                };

                                const labelToToken = new Map();
                                vendorObjs.forEach((v) => {
                                    const key = normalizeLabel(labelForVendor(v));
                                    if (key) labelToToken.set(key, v?.token);
                                });

                                const resolveTokenFromLabel = (label) => {
                                    const normalized = normalizeLabel(label);
                                    if (!normalized) return null;
                                    const direct = labelToToken.get(normalized);
                                    if (direct) return direct;

                                    const m = normalized.match(/^(.*)\\((.*)\\)$/);
                                    if (!m) return null;
                                    const name = normalizeLabel(m[1]);
                                    const email = normalizeLabel(m[2]);
                                    const exact = vendorObjs.find(
                                        (v) =>
                                            normalizeLabel(v?.companyName) === name &&
                                            normalizeLabel(v?.email) === email,
                                    );
                                    return exact?.token || null;
                                };

                                const selectedVendorTokens = (selectedValues || [])
                                    .map((val) => resolveTokenFromLabel(val))
                                    .filter(Boolean);

                                const selectedVendors = selectedVendorTokens
                                    .map((token) => fullDetails[token])
                                    .filter(Boolean);

                                setVendor({
                                    value: selectedValues,
                                    fullDetails: selectedVendors,
                                    isValid: selectedValues.length !== 0,
                                });
                            }}
                            error={!vendor.isValid}
                            errorMsg={"Supplier is required"}
                            size={"100%"}
                        />
                    </div>

                        <div className={classes.submitVendorContainer}>
                            {!showmessagebtn && <DButton
                                label={"Add Supplier"}
                                btnWidth={"17rem"}
                                btnHeight={"4rem"}
                                onClick={handleOpen1}
                            />}
                            {showmessagebtn && vendor.value.length > 0 && <DButton
                                label={"Message Supplier"}
                                btnWidth={"17rem"}
                                btnHeight={"4rem"}
                                onClick={handleVendorMessagePopup}
                            />}


                            {!showmessagebtn && <DButton
                                label={"Create RFQ"}
                                btnWidth={"17rem"}
                                btnHeight={"4rem"}
                                disabled={
                                    !vendor.value.length ||
                                    !selectedaddress ||
                                    !String(bidType ?? "").trim() ||
                                    !bidstartdate?.isValid() ||
                                    !bidenddate?.isValid() ||
                                    !bidendtime?.isValid() ||
                                    !/^[A-Za-z0-9/_-]{1,10}$/.test(String(prNumber || "").trim()) ||
                                    !String(org_details.find((field) => field.label === "RFQ Code" || field.label === "RFQ ID")?.value ?? "").trim() ||
                                    (inputMethod === "xls"
                                        ? !fileUpload
                                        : !items.length ||
                                          hasAnyQuickDuplicates(items) ||
                                          !items.every((item) =>
                                              String(item?.itemName || "").trim() &&
                                              String(item?.unit || "").trim() &&
                                              String(item?.quantity || "").trim()
                                          ))
                                }
                                loadingState={loading || (isFreeRfq && freeRfqCodeLoading)}
                                onClick={handleQuickRFQSave}
                            />}
                        </div>
                </>
            )}

            <Modal
                open={openAddAddressModal}
                onClose={() => setOpenAddAddressModal(false)}
                closeAfterTransition
                slotProps={{
                    backdrop: { TransitionComponent: Fade },
                }}
            >
                <Fade in={openAddAddressModal}>
                    <Box className={classes.modalWrapper}>
                        <PopupFrame
                            poupHeading={<HeaderTitle titleText="Add New Address" />}
                            inputChildren={[
                                <div className={classes.addressForm}>
                                    <DTextInput label="Shipping Address 1" size="100%" />
                                    <DTextInput label="Shipping Address 2" size="100%" />
                                    <DTextInput label="City" size="100%" />
                                    <DTextInput label="State" size="100%" />
                                    <DTextInput label="Country" size="100%" />
                                    <DTextInput label="Pincode" size="100%" />
                                    <DTextInput label="Mobile Number" size="100%" />
                                </div>
                            ]}
                            actionButtons={[
                                <DButtonOutlined label="Cancel" onClick={() => setOpenAddAddressModal(false)} />,
                                // <DButton label="Add Address" onClick={handleAddAddressSubmit} />,
                            ]}
                        />
                    </Box>
                </Fade>
            </Modal>




            <Modal open={successpopup}>
                <Fade in={successpopup}>
                    <Box>
                        <SuccessPopupDashboard
                            popupImage={successPopupImg}
                            popupHeroText={getuserpopupherotext}
                            popBtn={true}
                            vendorBtn={true}
                            btnText={"Okay"}
                            btnClick={clearAllState}
                        />
                    </Box>
                </Fade>
            </Modal>

            <Modal open={openvendormodal}
                closeAfterTransition
                slotProps={{
                    backdrop: {
                        TransitionComponent: Fade,
                    },
                }}
            >
                <Fade in={openvendormodal}>

                    <div
                        className={classes.flex}
                        style={{
                            height: "130vh",
                        }}
                    >

                        <PopupFrame
                            poupHeading={vendorMessageHeader}
                            inputChildren={vendorTextArea}
                            actionButtons={vendorActionBtn}
                        />
                    </div>
                </Fade>
            </Modal>

            {/* add vendor */}


            <Modal
                open={openaddvendor}
                closeAfterTransition
                slotProps={{
                    backdrop: {
                        TransitionComponent: Fade,
                    },
                }}
                sx={{
                    overflow: "auto",
                }}
            >
                <Fade in={openaddvendor}>
                    <div
                        className={classes.flex}
                        style={{
                            height: "100vh",
                        }}
                    >

                        <PopupFrame
                            customClass={vendorClasses.InviteVendorPopup}
                            styleCenterDiv={classes.centerDiv}
                            inputChildren={vendorsTabInputs}
                            poupHeading={vendorsTabHeading}
                            actionButtons={popupActions}
                        />

                    </div>
                </Fade>
            </Modal>


        </div>
    );
}

export default QuickRFQ;
